import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Box,
  Flex,
  Grid,
  Group,
  Popover,
  Radio,
  Select,
  Text,
  TextInput,
  Textarea,
  Tooltip,
  rem,
  Drawer,
  ActionIcon,
  Checkbox,
  UnstyledButton,
  Skeleton,
  Button,
  Divider,
} from "@mantine/core";
import { DateInput, DatePickerInput, TimeInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { TbPlus, TbTrash } from "react-icons/tb";
import { useMediaQuery } from "@mantine/hooks";
import { IconInfoCircle } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { createNote, editNote, generateAiNote } from "../../services/note";
import { getAllPatientsModal } from "../../services/patient";
import {
  decrypt,
  formatDate,
  getNameFromAbbreviation,
  getOptions,
  noteType_Client,
  noteType_Client_Options,
} from "../../utils";
import useStyles from "./styles";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { IconChevronDown } from "@tabler/icons-react";
import { getAllFacilities, getAllFacilitiesModal } from "../../services";
import { planTypeLabels } from "../MAR/ClientSupportPlans";
import EssentialViewInfo from "./EssentialViewInfo";
import { MicAiSvg } from "../Svgs/MicAiSvg";
import {
  Billing_Services_Note,
  Essential_Support_Note,
  Intervention_Progress_Note,
  PROGRESS_Note,
} from "../../http";
import ButtonComp from "../ButtonComponent/ButtonComp";
import { RiDeleteBin7Line } from "react-icons/ri";
import GroupedButtons from "../GroupedButtons/GroupedButtons";
import CustomModal from "../CustomModal/CustomModal";
import pendingModalIcon from "../../images/pendingModalIcon.png";
import NoteTypeComp from "../NoteTypeComp/NoteTypeComp";
import DateSvg from "../Svgs/DateSvg";
import { AiOutlineDelete } from "react-icons/ai";
import NotePendingSvg from "../Svgs/NotePendingSvg";
import ViewInfo from "./ViewInfo";
import AiAssistantChatCard from "../AiAssistantChatCard";
import { AutoFillSvg } from "../Svgs/AutoFillAiSvg";
import { useSpeechToText } from "./useSpeechToText";
import RecordingControls from "./RecordingControls";
import swal from "sweetalert";
import { getSkaiTokenUsage } from "../../services/skaiTokens";
import moment from "moment";
import RewriteNoteAiSvg from "../Svgs/RewriteNoteAiSvg";
import PolishNoteAiSvg from "../Svgs/PolishNoteAi";
import AiActionButtons from "./AiActionButtons";
import ElaborateAiSvg from "../Svgs/ElaborateAiSvg";

const NoteDrawer = ({
  opened,
  close,
  title,
  view,
  setView,
  userId,
  noteType: NOTETYPE,
  setOpenModal,
  setBillingServices,
  setProgressNoteState,
  progressNoteState,
  clientDetails,
  ...data
}) => {
  // Get the current time in HH:mm:ss format
  const { sortField, sortOrder } = data;
  const { classes } = useStyles();
  const ref = useRef();
  const edit = data.data ? true : false;
  const noteT = data?.data?.noteId;
  let getEssentialSupport = data?.data?.essentialSupport;
  let getGoalsData = data?.data?.goals;
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPlans } = useSelector((state) => state?.supportPlan);
  const { profile } = useSelector((state) => state.profile);
  const { allPatients } = useSelector((state) => state?.patient);
  const { facilities } = useSelector((state) => state.facility);
  const [messages, setMessages] = useState([]);

  const [errors, setErrors] = useState({});
  const [outcomeNotes, setOutcomeNotes] = useState([]);
  const [essentialNotes, setEssentialNotes] = useState([]);
  const [essentialSupportCount, setEssentialSupportCount] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [facilityDetials, setFacilityDetials] = useState(null);
  const [medicationOptions, setMedicationOptions] = useState([]);
  const [supportOptions, setSupportOptions] = useState([]);
  const [outComeTitle, setOutComeTitle] = useState([]);
  const [outcomeNumbers, setOutComeNumbers] = useState([]);
  const [essentialSupportType, setEssentialSupportType] = useState([]);
  const [essentialSupportNumber, setEssentialSupportNumber] = useState([]);
  const [noteType, setNoteType] = useState(
    noteT
      ? allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)
      : allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)
  );
  const [showAiButtons, setShowAiButtons] = useState(false);
  const [pendingModal, setPendingModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [currentNote, setCurrentNote] = useState("");
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const [supportPlan, setSupportPlan] = useState("no");
  const [openedAccordion, setOpenedAccordion] = useState("0");
  const [essentialAccordion, setEssentialAccordion] = useState("0");
  const [essentialSupportToggle, setEssentialSupportToggle] = useState("no");
  const [interventionPlanToggle, setInterventionPlanToggle] = useState("no");

  const [serviceNumber, setServiceNumber] = useState(null);
  const icon = (
    <DropDownArrowSvg color={true} style={{ width: rem(1), height: rem(1) }} />
  );
  const [isListening, setIsListening] = useState(false);
  const [micLabel, setMicLabel] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [recordingType, setRecordingType] = useState(null);
  const [essentialSupportErrors, setEssentialSupportErrors] = useState([]);

  const timerRef = useRef(null);

  const [aiAssistantCardOpened, setAiAssistantCardOpened] = useState(false);
  const isEssentialSupport = noteType?.id === Essential_Support_Note;
  const isBilling_Services = noteType?.id === Billing_Services_Note;
  const isIntervention_Progress_Note =
    noteType?.id === Intervention_Progress_Note;
  const initialDescription = {
    outcomeTitle: "",
    outcomeNumber: "",
    outComeCategory: "",
    description: "",
    details: null,
    error: "",
    planId: "1",
  };

  const initialEssentialSupport = {
    id: Date.now(),
    essentialSupportType: "",
    essentialActivityNumber: "",
    description: "",
  };

  const initialGoals = {
    id: Date.now(),
    goalNumber: "",
    goalNote: "",
    startTimeGoal: "",
    endTimeGoal: "",
    goalActivities: [
      { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    ],
    behaviorDescription: "",
    responseDescription: "",
    planDescription: "",
  };
  const [selectedFacility, setSelectedFacility] = useState();
  const today = new Date();

  const [descriptions, setDescriptions] = useState([
    { id: 1, ...initialDescription },
  ]);

  const [essentialSupport, setEssentialSupport] = useState([
    { id: 1, ...initialEssentialSupport },
  ]);

  const [goals, setGoals] = useState([{ id: 1, ...initialGoals }]);

  const { staff } = useSelector((state) => state.staff);
  const { allSignature } = useSelector((state) => state?.signature);
  const [staffDetials, setStaffDetials] = useState();
  React.useEffect(() => {
    setDescriptions([{ id: 1, ...initialDescription }]);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
  }, [selectedFacility]);

  useEffect(() => {
    setRecordingType(null);
  }, []);

  const usageData = useSelector((state) => state.skai.usageHistory);
  const [showWarning, setShowWarning] = useState(false);
  const [messageValue, setMessageValue] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [selectedSupportType, setSelectedSupportType] = useState(null);
  const [activities, setActivities] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [essentialNumber, setEssentialNumber] = useState(null);
  const [behaviorCardOpened, setBehaviorCardOpened] = useState(false);
  const [responseCardOpened, setResponseCardOpened] = useState(false);
  const [planCardOpened, setPlanCardOpened] = useState(false);
  const [behaviorLoading, setBehaviorLoading] = useState(false);
  const [responseLoading, setResponseLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectedStateAbbr = getNameFromAbbreviation(
    selectedPatient?.form1?.state
  );

  const usageArray = Array.isArray(usageData) ? usageData : [];
  const existingRecord = usageArray.find(
    (item) =>
      item?.admin === profile?.user?.admin || item?.admin === profile?.user?.id
  );

  const checkTokenUsageWarning = (existingRecord, values) => {
    if (existingRecord?.active === false && existingRecord?.paid === false) {
      swal({
        title: "AI Note Assistant Credits Not Found",
        text: "You have not purchased any AI credits yet. Please visit the Settings page and navigate to the AI credits section to buy credits.",
        icon: "info",
        dangerMode: false,
      });

      return;
    }
    if (existingRecord?.planType === "onetime-purchase") {
      const tokensUsage = existingRecord?.adminTotalTokens;

      const totalTokens = Number(tokensUsage?.adminTotalTokens);
      const usedTokens = Number(tokensUsage?.adminUsedTokens);

      const originalTotal = totalTokens + usedTokens;

      const percentageUsed =
        originalTotal > 0 ? Math.round((usedTokens / originalTotal) * 100) : 0;

      if (percentageUsed >= 100) {
        setShowWarning(true);
        swal({
          title: "AI Note Assistant Quota Reached",
          text: "You’ve reached your monthly AI Note Assistant quota. Please contact your admin if you need additional access.",
          icon: "error",
          dangerMode: true,
        });
        return; // Do NOT allow AI usage
      }

      if (percentageUsed >= 90) {
        setShowWarning(true);
        swal({
          title: "AI Note Assistant Quota Exceeded",
          text: "You’ve used 90% of your AI Note Assistant quota for this month. Continued use may require admin approval.",
          icon: "warning",
          dangerMode: true,
        });
      }
    }
    sendMessageToOpenAI(values);
    if (values === "behavior") {
      setBehaviorCardOpened(true);
    } else if (values === "response") {
      setResponseCardOpened(true);
    } else if (values === "plan") {
      setPlanCardOpened(true);
    } else {
      setAiAssistantCardOpened(true);
    }

    setShowWarning(false);
  };

  useEffect(() => {
    getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
  }, [profile]);

  useEffect(() => {
    getAllFacilities(1);
    // getAllSignatures();
  }, []);

  const [essentialSupportTypeState, setEssentialSupportTypeState] = useState(
    []
  );
  const [goalsAccordion, setGoalsAccordion] = useState("0");
  const [goalOptions, setGoalOptions] = useState([]);
  const [goalNumber, setGoalNumbers] = useState([]);
  const [objectivesByGoal, setObjectivesByGoal] = useState([]);
  const [interventionsByGoal, setInterventionsByGoal] = useState([]);
  const [goalItems, setGoalItems] = useState([
    [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
  ]);

  const isAddDisabled =
    goalItems[goalItems.length - 1].length >=
    Math.min(objectivesByGoal.length, interventionsByGoal.length);

  // Add row
  const handleAddGoalItem = (index) => {
    let tempGoalItems = [...goalItems];

    tempGoalItems[index].push({
      id: Date.now(),
      objectives: "",
      Intervention_Instruction: "",
    });

    setGoalItems(tempGoalItems);
    // setGoalItems((prev) => [
    //   ...prev,
    //   { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    // ]);
  };

  // Remove row
  const handleRemoveGoalItem = (id, goalIndex) => {
    const updatedGoalItems = goalItems[goalIndex].filter(
      (item) => item.id !== id
    );
    let finalGoalItems = [...goalItems];
    finalGoalItems[goalIndex] = updatedGoalItems;
    setGoalItems(finalGoalItems);
    // setGoalItems(updatedGoalItems);
    setGoals((prevGoals) =>
      prevGoals.map((goal, index) =>
        index === goalIndex
          ? { ...goal, goalActivities: updatedGoalItems }
          : goal
      )
    );
  };

  useEffect(() => {
    let outcomeTitle = [];
    let outcomeNumberArray = [];
    let essentialSupportArray = [];
    let essentialSupportNumber = [];
    let planIdToSave = null;
    let goalTitleOptions = [];
    let goalNumberOptions = [];

    if (noteType?.name === "Intervention Progress Note") {
      const filteredGoals = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.goals?.map((goal) => {
                if (edit) {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                    });
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });
                  }
                }
              });
              return v;
            })
        : [];
    } else {
      const filtered = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.outcomes?.map((vv) => {
                // If block is for edit and else block is for add
                if (edit) {
                  // Check if care plan is acive or discontinued
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    // if care plan is active then push all the outcomes
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });

                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        setEssentialSupportCount(
                          v?.essentialSupport?.flatMap((_es) => _es?.activities)
                        );
                        // setEssentialSupportCount(v?.essentialSupport);
                      }
                    }
                  } else if (
                    v?.status === "discontinued" &&
                    v?.isActive === false
                  ) {
                    // if care plan is discontinued then check if one of its outcome is used while creating progress note
                    let filteredDesc = data?.data?.descriptions?.filter(
                      (_d) => _d?.outcomeNumber === vv?.id
                    );

                    if (filteredDesc?.length > 0) {
                      // if outcome is used then push the outcome
                      outcomeTitle.push({
                        value: vv?.id,
                        label: `${vv?.outcomeTitle} (D)`,
                        disabled: true,
                      });
                      outcomeNumberArray.push({
                        value: vv?.id,
                        label: `${vv?.outcomeNumber} (D)`,
                        disabled: true,
                      });
                    }
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    // If planType is present then save the planId to state for labels
                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        setEssentialSupportCount(
                          v?.essentialSupport?.flatMap((_es) => _es?.activities)
                        );
                        // setEssentialSupportCount(v?.essentialSupport);
                      }
                    }

                    return v;
                  }
                }
              });

              if (
                v?.status === "active" &&
                v?.isActive === true &&
                v?.deleted !== true
              ) {
                v?.essentialSupport?.map((vv) => {
                  essentialSupportArray.push({
                    value: vv?.id,
                    label: vv?.essentialSupportType,
                  });

                  vv?.activities?.map((_a) => {
                    essentialSupportNumber.push({
                      value: _a?.id,
                      label: _a?.supportStatement,
                    });
                  });
                });
                // Get essential support types
                const getEssentialSupportTypes = Array.from(
                  new Set(
                    v?.essentialSupport?.map(
                      (item) => item.essentialSupportType
                    )
                  )
                ).filter(Boolean);

                const formatted = getEssentialSupportTypes.map((type) => ({
                  label: type,
                  value: type,
                }));
                setEssentialSupportTypeState(formatted);

                // Filter activities based on the selected support type
                const filteredData = v?.essentialSupport?.filter(
                  (item) => item.essentialSupportType === selectedSupportType
                );
                const allActivities = filteredData?.map(
                  (item) => item.activities
                );
                // setActivities(allActivities);
              }
            })
        : [];
    }
    // setObjectivesByGoal(objectivesMap);
    // setInterventionsByGoal(interventionsMap);

    setGoalOptions(goalTitleOptions);
    setGoalNumbers(goalNumberOptions);
    // setGoalActivities(goalActivitiesOptions);

    // Set the planId to the state
    if (planIdToSave) {
      // setSavePlanId(planIdToSave);
    }
    setEssentialSupportNumber(essentialSupportNumber);
    setEssentialSupportType(essentialSupportArray);
    setOutComeTitle(outcomeTitle || []);
    setOutComeNumbers(outcomeNumberArray || []);
    if (selectedPatient) {
      let serviceNumber = selectedPatient?.form1?.services?.filter(
        (i) => i?.servicenumber == data?.data?.fields["Service Type"]
      )?.[0];
      setServiceNumber(serviceNumber);
    }
  }, [selectedPatient, allPlans, selectedFacility, selectedSupportType, noteType]);

  // useEffect(() => {
  //   // essential support details
  //   allPlans
  //     ?.filter(
  //       (v) =>
  //         v?.client?._id === selectedPatient?.id &&
  //         v?.facility?._id === selectedFacility
  //     )
  //     ?.map((v) => {
  //       setOutcomesLength(v?.outcomes?.length);
  //     });
  // }, []);

  const handleSupportPlanChange = () => {
    setSupportPlan(supportPlan === "yes" ? "no" : "yes");
    setAiAssistantCardOpened(false);
    setMessages([]);
    setShowAiButtons(false);
    form.setFieldValue("Description", "");
    descriptions[descriptions?.length - 1].description = "";
  };

  // Add New Outcome Handler
  const addDescription = (e) => {
    setAiAssistantCardOpened(false);
    handleRecordingConfirm();
    // setMessages([]);
    if (descriptions) {
      setDescriptions([
        ...descriptions,
        { id: Date.now(), ...initialDescription },
      ]);
      setOpenedAccordion(`${descriptions?.length}`);
    }
  };

  // // Add New Essential Support Handler
  const addEssentialSupport = () => {
    setAiAssistantCardOpened(false);

    handleRecordingConfirm();
    if (essentialSupport?.length < essentialSupportCount?.length) {
      setEssentialSupport([
        ...essentialSupport,
        {
          id: Date.now(),
          ...initialEssentialSupport,
        },
      ]);
      setEssentialAccordion(`${essentialSupport?.length}`);
    }
  };

  // // Add New Goal handler
  const addNewGoal = () => {
    // setAiAssistantCardOpened(false);

    // handleRecordingConfirm();
    if (goals?.length < goalOptions?.length) {
      setGoals([
        ...goals,
        {
          id: Date.now(),
          ...initialGoals,
          goalActivities: [
            { id: Date.now(), objectives: "", Intervention_Instruction: "" },
          ],
        },
      ]);
      setGoalsAccordion(`${goals?.length}`);
      setGoalItems([
        ...goalItems,
        [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
      ]);
      setBehaviorCardOpened(false);
      setResponseCardOpened(false);
      setPlanCardOpened(false);
    }
  };

  // Remove Outcome Handler
  const removeMedication = (medicationId) => {
    setDescriptions(descriptions?.filter((med) => med.id !== medicationId));
  };

  // Remove Essential Support Handler
  const removeEssentialSupport = (medicationId) => {
    const filtered = essentialSupport?.filter((med) => {
      return med.id !== medicationId;
    });
    setEssentialSupport(filtered);
  };

  // Remove goal Handler
  const removeGoal = (Id) => {
    const filtered = goals?.filter((item) => {
      return item.id !== Id;
    });
    setGoals(filtered);
  };

  // Edit Outcome Inputs Handler
  const handleMedicationChange = (medicationId, field, value, indexx) => {
    let filteredObj = null;
    if (field === "outcomeTitle") {
      filteredObj = outComeTitle?.filter((item) => item?.value === value)?.[0];
    } else if (field === "outcomeNumber") {
      filteredObj = outcomeNumbers?.filter(
        (item) => item?.value === value
      )?.[0];
    }

    let previous = descriptions?.find(
      (v) => v?.outcomeTitle === value || v?.outcomeNumber === value
    );
    let rest = {};
    let choosenPlan = null;
    if (field === "outcomeTitle" || field === "outcomeNumber") {
      let { id, ...others } = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility
        )
        ?.filter((_fp) => _fp?.outcomes?.find((_oc) => _oc?.id === value))?.[0]
        ?.outcomes?.find((v) => v?.id === value);
      rest = others;

      allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility
        )
        ?.map((_fp) => {
          if (_fp?.outcomes?.find((_oc) => _oc?.id === value)) {
            choosenPlan = _fp;
          }
        });
    }

    setDescriptions((prevMedications) =>
      prevMedications.map((med, index) => {
        if (index === indexx) {
          if (field !== "metGoal" && field !== "description") {
            return med?.id === medicationId
              ? {
                  ...med,
                  ...(outcomeNotes[index]?.length > 0 && {
                    description: outcomeNotes[index],
                  }),
                  [field]: value,
                  [field == "outcomeTitle" ? "outcomeNumber" : "outcomeTitle"]:
                    filteredObj?.value,
                  outComeCategory:
                    field === "outcomeTitle" || field === "outcomeNumber"
                      ? allPlans
                          ?.filter(
                            (v) =>
                              v?.client?._id === selectedPatient?.id &&
                              v?.facility?._id === selectedFacility
                          )
                          ?.filter((_fp) =>
                            _fp?.outcomes?.find((_oc) => _oc?.id === value)
                          )?.[0]
                          ?.outcomes?.find((v) => v?.id === value)
                          ?.outcomeCategory
                      : med?.outComeCategory,
                  details:
                    field === "outcomeTitle" || field === "outcomeNumber"
                      ? filterNonNullFields(rest)
                      : med?.details,
                  error: previous ? "Already Selected" : null,
                  planId: choosenPlan ? choosenPlan?.planType?.planId : "1",
                }
              : med;
          } else {
          }
          let obj = {
            ...med,
            [field]: value,
            outComeCategory:
              field === "outcomeTitle" || field === "outcomeNumber"
                ? allPlans
                    ?.filter(
                      (v) =>
                        v?.client?._id === selectedPatient?.id &&
                        v?.facility?._id === selectedFacility
                    )
                    ?.filter((_fp) =>
                      _fp?.outcomes?.find((_oc) => _oc?.id === value)
                    )?.[0]
                    ?.outcomes?.find((v) => v?.id === value)?.outcomeCategory
                : med?.outComeCategory,
            details:
              field === "outcomeTitle" || field === "outcomeNumber"
                ? filterNonNullFields(rest)
                : med?.details,
            error: previous ? "Already Selected" : null,
          };
          if (field === "outcomeTitle" || field === "outcomeNumber") {
            obj.planId = choosenPlan ? choosenPlan?.planType?.planId : "1";
          }
          return med.id === medicationId ? obj : med;
        } else {
          return med;
        }
      })
    );
    setErrors("");
  };

  const handleEssentialTypeChange = (supportId, field, value, indexx) => {
    if (field === "identifiedGoal") {
      // setGoalItems([
      //   { id: Date.now(), objectives: "", Intervention_Instruction: "" },
      // ]);
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  goalNumber: "",
                }
              : item;
          } else {
            return item;
          }
        })
      );
      const matchingGoal = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility &&
            v?.status === "active" &&
            v?.isActive === true &&
            v?.deleted !== true
        )
        ?.flatMap((v) => v?.goals || [])
        ?.filter((_g) => _g?.Identified_Relevant_Attainable_Goals === value);

      const formattedObjectives = matchingGoal?.flatMap(
        (goal) =>
          goal?.goalActivities?.map((_ga) => ({
            label: _ga.objectives,
            value: _ga.objectives,
          })) || []
      );
      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = matchingGoal?.flatMap(
        (goal) =>
          goal?.goalActivities?.map((_ga) => ({
            label: _ga.Intervention_Instruction,
            value: _ga.Intervention_Instruction,
          })) || []
      );
      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );

      let newGoalItems = [...goalItems];
      newGoalItems[indexx] = [
        {
          id: Date.now(),
          objectives: "",
          Intervention_Instruction: "",
        },
      ];
      setGoalItems(newGoalItems);
      const formattedGoalNumber = Array.from(
        new Set(matchingGoal.map((item) => item?.goalNumber).filter(Boolean))
      ).map((freq) => ({
        label: freq,
        value: freq,
      }));
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx && item.id === supportId) {
            return {
              ...item,
              goalNumber: formattedGoalNumber?.map((goal) => goal.value)[0],
            };
          }
          return item;
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  essentialSupportType: value,
                  howOftenEssentialSupport: "", // reset on type change
                  essentialNumber: "", // reset on type change
                  essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
      setSelectedSupportType(value);

      const matchingSupport = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility &&
            v?.status === "active" &&
            v?.isActive === true &&
            v?.deleted !== true
        )
        ?.flatMap((v) => v?.essentialSupport || [])
        ?.filter((_es) => _es?.essentialSupportType === value);

      // ✅ Handle both old and new data structures
      // const allFrequencies =
      //   matchingSupport?.flatMap((support) => {
      //     // case 1: old structure (top-level howOftenEssentialSupport)
      //     if (support?.howOftenEssentialSupport) {
      //       return support?.howOftenEssentialSupport;
      //     }

      //     // case 2: new structure (inside activities)
      //     if (Array.isArray(support?.activities)) {
      //       return support?.activities
      //         ?.map((activity) => activity?.howOftenEssentialSupport)
      //         ?.filter(Boolean);
      //     }
      //     return [];
      //   }) || [];

      const allFrequencies =
        matchingSupport?.flatMap((support) => {
          // 1️⃣ First check inside activities
          const activityFrequencies =
            support?.activities
              ?.map((activity) => activity?.howOftenEssentialSupport)
              ?.filter(Boolean) || [];

          // 2️⃣ If found inside activities, use them
          if (activityFrequencies.length > 0) {
            return activityFrequencies;
          }

          // 3️⃣ Otherwise, fall back to top-level
          if (support?.howOftenEssentialSupport) {
            return [support?.howOftenEssentialSupport];
          }

          // 4️⃣ Default: return empty array
          return [];
        }) || [];

      const uniqueFrequencies = [...new Set(allFrequencies)];

      const formattedFrequency = uniqueFrequencies.map((freq) => ({
        label: freq,
        value: freq,
      }));

      setFrequencyOptions(
        formattedFrequency.length > 0 ? formattedFrequency : []
      );

      // ✅ Extract all activities from matching supports
      const allActivities =
        matchingSupport?.flatMap((support) => support?.activities || []) || [];

      // ✅ Format activities for the dropdown
      const formattedActivities = allActivities.map((activity) => ({
        supportStatement: activity?.supportStatement,
        id: activity?.id,
      }));
      setActivities(formattedActivities);
    }
  };

  const handleEssentialTypeChangeForNoteView = (value, frequency) => {
    const matchingSupport = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.essentialSupportType === value);

    if (!matchingSupport?.length) return;

    let allFrequencies = [];
    matchingSupport?.forEach((item) => {
      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport && item?.essentialSupportType === value
      );
      if (foundActs?.length) {
        foundActs.forEach((act) =>
          allFrequencies.push(act?.howOftenEssentialSupport)
        );
      } else if (item?.howOftenEssentialSupport) {
        allFrequencies.push(item?.howOftenEssentialSupport);
      }
    });

    const formattedFrequency = Array.from(new Set(allFrequencies)).map(
      (freq) => ({ label: freq, value: freq })
    );
    setFrequencyOptions(formattedFrequency);

    const matchingFrequencySupports = matchingSupport?.filter((_es) => {
      const hasActivityMatch = _es?.activities?.some(
        (act) =>
          act?.howOftenEssentialSupport === frequency &&
          _es?.essentialSupportType === value
      );
      return hasActivityMatch || _es?.howOftenEssentialSupport === frequency;
    });

    const formattedEssentialNumber = Array.from(
      new Set(
        matchingFrequencySupports
          ?.map((item) => item?.essentialNumber)
          ?.filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumber);

    let relatedActivities = [];
    matchingSupport?.forEach((item) => {
      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport === frequency &&
          item?.essentialSupportType === value
      );
      if (foundActs?.length) {
        relatedActivities.push(...foundActs);
      } else if (
        item?.howOftenEssentialSupport === frequency &&
        item?.essentialSupportType === value
      ) {
        relatedActivities.push({
          ...item,
          id: item.activities?.[0]?.id || item.id, // prefer activity id if available
          supportStatement:
            item.activities?.[0]?.supportStatement || item.supportStatement,
        });
      }
    });

    relatedActivities = relatedActivities.filter(
      (act, idx, self) => idx === self.findIndex((a) => a?.id === act?.id)
    );

    setActivities(relatedActivities);
  };

  const handleEssentialFrequencyChange = (supportId, field, value, indexx) => {
    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId
            ? {
                ...item,
                [field]: value,
                howOftenEssentialSupport: value,
                //essentialNumber: "",
                essentialNumber: item?.essentialNumber,
                essentialActivityNumber: "",
              }
            : item;
        } else return item;
      })
    );

    const allEssentialSupports = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || []);

    const filteredSupports = allEssentialSupports?.filter((_es) => {
      const hasActivityMatch = _es?.activities?.some(
        (act) =>
          act?.howOftenEssentialSupport === value &&
          _es?.essentialSupportType === selectedSupportType
      );
      return hasActivityMatch || _es?.howOftenEssentialSupport === value;
    });

    const formattedEssentialNumbers = Array.from(
      new Set(
        filteredSupports?.map((item) => item?.essentialNumber).filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumbers);

    let relatedActivities = [];
    filteredSupports?.forEach((item) => {
      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport === value &&
          item?.essentialSupportType === selectedSupportType
      );
      if (foundActs?.length) {
        relatedActivities.push(...foundActs);
      } else if (
        item?.howOftenEssentialSupport === value &&
        item?.essentialSupportType === selectedSupportType
      ) {
        relatedActivities.push({
          ...item,
          id: item.activities?.[0]?.id || item.id, // prefer activity id if available
          supportStatement:
            item.activities?.[0]?.supportStatement || item.supportStatement,
        });
      }
    });

    relatedActivities = relatedActivities.filter(
      (act, idx, self) => idx === self.findIndex((a) => a?.id === act?.id)
    );

    setActivities(relatedActivities);
  };

  const handleEssentialNumberChange = (supportId, field, value, indexx) => {
    if (field === "goalNumber") {
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  goalNumber: value,
                  // essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  essentialNumber: value,
                  essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
    }
  };
  const handleEssentialChange = (supportId, field, value, indexx) => {
    let filtered_plan_1 = allPlans?.filter(
      (v) =>
        v?.client?._id === selectedPatient?.id &&
        v?.facility?._id === selectedFacility &&
        v?.status === "active" &&
        v?.isActive === true &&
        v?.deleted !== true
    );

    // Find the essential support that includes this activity
    const selectedSupport = filtered_plan_1
      ?.flatMap((plan) => plan.essentialSupport || [])
      ?.find((es) => es.activities?.some((a) => a.id === value));

    const selectedActivity = selectedSupport.activities?.find(
      (a) => a.id === value
    );

    const allFrequencies = (() => {
      if (!selectedSupport) return [];

      // Case 1: Activities have their own howOftenEssentialSupport
      if (
        Array.isArray(selectedSupport?.activities) &&
        selectedSupport.activities.length > 0
      ) {
        const activityFrequencies = selectedSupport.activities
          .map((activity) => activity?.howOftenEssentialSupport)
          .filter(Boolean);

        if (activityFrequencies.length > 0) {
          return activityFrequencies;
        }
      }

      // Case 2: Top-level howOftenEssentialSupport (old structure)
      if (selectedSupport?.howOftenEssentialSupport) {
        return [selectedSupport.howOftenEssentialSupport];
      }

      return [];
    })();

    const uniqueFrequencies = [...new Set(allFrequencies)];

    const formattedFrequency = uniqueFrequencies.map((freq) => ({
      label: freq,
      value: freq,
    }));

    setFrequencyOptions(
      formattedFrequency.length > 0 ? formattedFrequency : []
    );

    // // Find the essential support that includes this activity
    // const selectedSupport = filtered_plan_1
    //   ?.flatMap((plan) => plan.essentialSupport || [])
    //   ?.find((es) => es.activities?.some((a) => a.id === value));

    // const matchingSupport = filtered_plan_1?.flatMap((v) => v?.essentialSupport || [])
    //   ?.filter((_es) => _es?.essentialSupportType === selectedSupport?.essentialSupportType);

    // const selectedActivity = selectedSupport.activities?.find(
    //   (a) => a.id === value
    // );

    // let allFrequencies = [];
    // matchingSupport?.forEach((item) => {
    //   const foundActs = item?.activities?.filter(
    //     (act) =>
    //       act?.howOftenEssentialSupport && item?.essentialSupportType === selectedSupport?.essentialSupportType
    //   );
    //   if (foundActs?.length) {
    //     foundActs.forEach((act) =>
    //       allFrequencies.push(act?.howOftenEssentialSupport)
    //     );
    //   } else if (item?.howOftenEssentialSupport) {
    //     allFrequencies.push(item?.howOftenEssentialSupport);
    //   }
    // });

    // const formattedFrequency = Array.from(new Set(allFrequencies)).map(
    //   (freq) => ({ label: freq, value: freq })
    // );
    // setFrequencyOptions(formattedFrequency);

    const finalHowOften =
      selectedActivity?.howOftenEssentialSupport ||
      selectedSupport?.howOftenEssentialSupport ||
      "";

    const formattedEssentialNumber = Array.from(
      new Set(
        filtered_plan_1
          ?.flatMap((v) => v?.essentialSupport || [])
          ?.map((item) => item?.essentialNumber)
          ?.filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumber);

    let selectedEsType = [];

    filtered_plan_1?.forEach((_fp) => {
      _fp?.essentialSupport?.forEach((_es) => {
        if (_es?.activities?.find((_a) => _a?.id == value)) {
          selectedEsType.push(_es);
        }
      });
    });

    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx && item.id === supportId) {
          const selectedSupport = selectedEsType?.[0];

          // const selectedActivity = selectedSupport?.activities?.find(
          //   (act) => act?.id === value
          // );

          return {
            ...item,
            ...selectedSupport,
            essentialActivityNumber: value,
            howOftenEssentialSupport: finalHowOften,
            essentialNumber: selectedSupport?.essentialNumber,
          };
        }
        return item;
      })
    );
  };

  // add note of respective essential plan
  const handleEssentialSupportDesc = (supportId, field, value, indexx) => {
    if (isIntervention_Progress_Note) {
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId ? { ...item, [field]: value } : item;
          } else {
            return item;
          }
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId ? { ...item, [field]: value } : item;
          } else {
            return item;
          }
        })
      );
    }
  };

  const handleGoalActivityChange = (id, field, value, index, goalIndex) => {
    const matchingActivities = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.goals || [])
      ?.flatMap((g) => g?.goalActivities || []);

    const updatedGoalItems = goalItems[goalIndex].map((item) => {
      if (item.id !== id) return item;

      if (field === "objectives") {
        const selectedActivity = matchingActivities?.find(
          (ga) => ga?.objectives === value
        );
        return {
          ...item,
          objectives: value,
          Intervention_Instruction:
            selectedActivity?.Intervention_Instruction || "",
        };
      }

      if (field === "Intervention_Instruction") {
        const selectedActivity = matchingActivities?.find(
          (ga) => ga?.Intervention_Instruction === value
        );
        return {
          ...item,
          Intervention_Instruction: value,
          objectives: selectedActivity?.objectives || "",
        };
      }

      return { ...item, [field]: value };
    });

    let finalGoalItems = [...goalItems];

    finalGoalItems[goalIndex] = updatedGoalItems;

    setGoalItems(finalGoalItems);
    // setGoalItems(updatedGoalItems);
    setGoals((prevGoals) =>
      prevGoals.map((goal, i) =>
        i === goalIndex ? { ...goal, goalActivities: updatedGoalItems } : goal
      )
    );
  };

  useEffect(() => {
    if (getGoalsData && getGoalsData.length > 0) {
      // Extract goal activities from all goals
      const allActivities = getGoalsData.flatMap(
        (goal) => goal.goalActivities || []
      );

      let finalGoalItems = [];

      getGoalsData?.map((_g, index) => {
        finalGoalItems.push(_g.goalActivities);
      });

      setGoalItems(finalGoalItems);

      // Set goal items for display
      // setGoalItems(allActivities);

      const formattedObjectives = allActivities?.map((_ga) => ({
        label: _ga.objectives,
        value: _ga.objectives,
      }));

      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = allActivities?.map((_ga) => ({
        label: _ga.Intervention_Instruction,
        value: _ga.Intervention_Instruction,
      }));

      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );
    }
  }, [getGoalsData]);

  // Reset Form
  const resetForm = () => {
    setErrors("");
    form.reset();
    setEssentialSupportErrors([]);

    setOutcomeNotes([]);
    setAiAssistantCardOpened(false);
    setBehaviorCardOpened(false);
    setResponseCardOpened(false);
    setPlanCardOpened(false);

    setEssentialNotes([]);
    setSupportPlan("no");
    setMessages([]);
    setEssentialSupportToggle("no");
    setInterventionPlanToggle("no");
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
    setGoalItems([
      [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
    ]);
    setShowAiButtons(false);
    setServiceNumber(null);
    handleRecordingCancel();
    setEssentialAccordion("0");
    setGoalsAccordion("0");

    setEssentialSupportTypeState([]);
    setEssentialSupportNumber([]);
    setSelectedSupportType(null);
    setEssentialNumber(null);
    setFrequencyOptions([]);
    setActivities([]);

    if (!progressNoteState === "progress") {
      setBillingServices("");
      setSelectedPatient(null);
    }
    if (NOTETYPE === Billing_Services_Note) {
      setBillingServices("");
      setSelectedPatient(null);
    }
    close();
    // setPatientsId(null);
  };

  const cancelForm = () => {
    setErrors("");
    form.reset();
    setNoteType(null);
    setOutcomeNotes([]);
    setAiAssistantCardOpened(false);
    setBehaviorCardOpened(false);
    setResponseCardOpened(false);
    setPlanCardOpened(false);

    setEssentialNotes([]);
    setSupportPlan("no");
    setMessages([]);
    setEssentialSupportToggle("no");
    setInterventionPlanToggle("no");
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
    setGoalItems([
      [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
    ]);
    setShowAiButtons(false);
    setServiceNumber(null);
    handleRecordingCancel();
    setEssentialAccordion("0");
    setGoalsAccordion("0");

    setEssentialSupportTypeState([]);
    setEssentialSupportNumber([]);
    setSelectedSupportType(null);
    setEssentialNumber(null);
    setFrequencyOptions([]);
    setActivities([]);

    if (!progressNoteState === "progress") {
      setBillingServices("");
      setSelectedPatient(null);
    }
    if (NOTETYPE === Billing_Services_Note) {
      setBillingServices("");
      setSelectedPatient(null);
    }
    close();
    // setPatientsId(null);
  };

  // Save Note
  const onSave = async (values) => {
    const NOTETYPE = noteType?.id;
    let obj = {
      noteId: NOTETYPE,
      fields: { ...values, noteId: NOTETYPE },
      supportPlan,
      userId,
    };
    if (NOTETYPE === Billing_Services_Note) {
      obj.fields["Facility Name"] = selectedPatient?.facilityId?.[0]?.id;
    }
    const isEssentialNote = noteType?.id === Essential_Support_Note;

    const isValid = validateEssentialSupport();
    if (!isValid && isEssentialNote && essentialSupportToggle === "yes") return;

    if (isEssentialNote) {
      if (essentialSupport !== undefined) {
        obj.essentialSupport = essentialSupport;
      }
      if (essentialSupportToggle !== undefined) {
        obj.essentialSupportToggle = essentialSupportToggle;
      }
    } else if (isIntervention_Progress_Note) {
      if (goals !== undefined) {
        obj.goals = goals;
      }
      if (interventionPlanToggle !== undefined) {
        obj.interventionPlanToggle = interventionPlanToggle;
      }
    }
    const isProgressNote = noteType?.name === "Progress Note";
    if (
      isProgressNote ||
      noteType?.custom?.find((_c) => _c?.field === "Support Plan")
    )
      obj["descriptions"] = descriptions;

    // if (isProgressNote) obj["descriptions"] = descriptions;

    // if (isProgressNote && supportPlan === "yes")
    //   obj.fields["Description"] = descriptions
    //     ?.map((rest) => rest?.details?.outcomeTitle)
    //     ?.join(", ");

    if (edit) {
      let fields = { ...values };
      delete fields["noteId"];
      delete fields["noteType"];
      const obj = {
        ...values,
        id: data?.data?.id,
        fields,
        supportPlan,
        userId,
        essentialSupport,
        essentialSupportToggle,
        goals,
        interventionPlanToggle,
        noteDate: values.Date,
      };
      if (
        isProgressNote ||
        noteType?.custom?.find((_c) => _c?.field === "Support Plan")
      )
        obj["descriptions"] = descriptions;
      // if (isProgressNote) obj["descriptions"] = descriptions;

      if (isProgressNote && supportPlan === "yes")
        obj.fields["Description"] = descriptions
          ?.map((rest) => rest?.details?.outcomeTitle)
          ?.join(", ");
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        editNote(obj, false, resetForm, sortField, sortOrder, setEditModal);
        resetForm();
        setErrors("");
      }
    } else {
      const validations = validateFields();
      let isBillingService = profile?.admin?.billingAgree;
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        await createNote(obj, resetForm);
        resetForm();
        setPendingModal(true);
        if (NOTETYPE === PROGRESS_Note) {
          let ifEssential = allPlans?.some((item) => {
            return (
              item?.isActive &&
              item?.planType?.name?.includes("Essential Supports") &&
              item?.essentialSupport?.length
            );
          });
          if (ifEssential) {
            setOpenModal(true);
            setProgressNoteState("progress");
          } else if (isBillingService) {
            setOpenModal(true);
            setBillingServices("billing");
          } else {
            setOpenModal(false);
          }
        } else if (NOTETYPE === Essential_Support_Note) {
          if (progressNoteState && isBillingService) {
            // setOpenModal(true);
            setBillingServices("billing");
          } else {
            setOpenModal(false);
          }
        } else {
          setOpenModal(false);
        }
        setErrors("");
      }
    }
  };

  function objectToString(obj) {
    let result = Object.entries(obj)
      .map(
        ([key, value]) =>
          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${`"${
            value || "-"
          }"`}`
      )
      .join("\n");

    return result;
  }

  const arrayToString = (array) => {
    if (array?.length === 0 || array === undefined) return "";
    return array
      ?.filter((v) => v)
      ?.map((v, i) => `${i + 1}) ${v}`)
      .join("\n \n");
  };

  function filterNonNullFields(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== null && value !== undefined && value !== "") {
        result[key] = value;
      }
    }
    return result;
  }

  useEffect(() => {
    if (selectedPatient && isBilling_Services) {
      form.setFieldValue("Provider", selectedPatient?.providerId[0]?.id);
    }
  }, [selectedPatient]);

  useEffect(() => {
    if (essentialSupport) {
      let data = getEssentialSupport?.[0];

      if (view === true || edit === true) {
        handleEssentialTypeChangeForNoteView(
          data?.essentialSupportType,
          data?.howOftenEssentialSupport
        );
      }
    }
  }, [view, edit, essentialSupportToggle]);

  // useEffect(() => {
  // if(essentialSupport?.length > 0 && view === true) {
  //   let data = getEssentialSupport?.[0]
  //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport)
  // }
  // }, [view]);

  // useEffect(() => {
  // if(essentialSupport?.length > 0 && edit === true){
  //   let data = getEssentialSupport?.[0]
  //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport)
  // }
  // }, [edit]);

  // Handle Client Change
  const handlePatientChange = (patientId, name) => {
    if (name === "Service Type") {
      let selectedService = selectedPatient?.form1?.services?.filter(
        (val) => val?.servicenumber === patientId
      )?.[0];
      setServiceNumber(selectedService);
    }
    // setPatientsId(patientId);
    !edit && !view && setDescriptions([{ id: 1, ...initialDescription }]);

    form.setFieldValue(name, patientId);
    let facilityExists = noteType?.custom?.find(
      (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
    );
    let patient = allPatients?.find((value) => value?.id === patientId);

    let pcpInfo = {
      "PCP Name": patient?.form2?.["pcpName"],
      "PCP Email": patient?.form2?.["pcpEmail"],
      "PCP Phone Number": patient?.form2?.["pcpPhoneNumber"],
      "PCP Fax Number": patient?.form2?.["pcpFaxNumber"],
    };

    let insuranceDetails = {
      "Insurance Company Name": patient?.form2?.["insuranceCompanyName"],
      "Member Name": patient?.form2?.["memberName"],
      "Member Number": patient?.form2?.["memberNumber"],
      "Prescription Group": patient?.form2?.["prescriptionGroup"],
      "Group Number": patient?.form2?.["groupNumber"],
      "Effective Date": formatDate(patient?.form2?.["effectiveDate"]),
    };
    (edit || view) &&
      form.setFieldValue(
        facilityExists?.field,
        data?.data?.fields?.["Facility Name"]
      );

    form.setFieldValue("All PCP Info", objectToString(pcpInfo));
    form.setFieldValue(
      "Known Allergies",
      arrayToString(patient?.form1?.knownAllergies)
    );
    form.setFieldValue(
      "Dietary Restrictions",
      arrayToString(patient?.form1?.dietaries)
    );

    form.setFieldValue(
      "Known Illnes",
      arrayToString(
        patient?.form1?.knownIllness
          ? patient?.form1?.knownIllness?.map(
              (v) =>
                `${v?.illness || ""} - Contagious: "${v?.contagious || ""}"`
            )
          : []
      ) || "-"
    );
    form.setFieldValue("Insurance Details", objectToString(insuranceDetails));
    form.setFieldValue("Known Wounds", patient?.form1?.woundsInformation);

    form.setFieldValue("Medication Records", "");
    form.setFieldValue("Support Plan", "");
    setMedicationOptions(
      Array.isArray(patient?.form3)
        ? patient?.form3?.map((value) => {
            let { isPrescribed, id, ...rest } = value;
            return {
              label: value?.medicationName,
              value: objectToString({
                ...filterNonNullFields(rest),
                Prescribed: isPrescribed ? "Yes" : "No",
              }),
            };
          })
        : []
    );

    setSupportOptions(
      allPlans
        ?.find((v) => v?.client?.id === patient?.id)
        ?.outcomes?.map(({ id, ...rest }) => ({
          value: objectToString({
            ...filterNonNullFields(rest),
          }),
          label: rest.outcomeTitle,
        })) || []
    );
    if (patient) setSelectedPatient(patient);
  };

  // Handle Facility Change
  const handleFacilityChange = (value, name) => {
    form.setFieldValue(name, value);
    setSelectedFacility(value);
    let facilityDetails = facilities?.facilities?.find(
      (fac) => String(fac?.id) === value
    );
    setFacilityDetials(facilityDetails);
  };

  useEffect(() => {
    if (!opened) {
      setMedicationOptions([]);
      setSupportOptions([]);
      setDescriptions([{ id: 1, ...initialDescription }]);
      setSupportPlan("no");
      setEssentialSupportToggle("no");
      setInterventionPlanToggle("no");
      getAllFacilitiesModal("all");

      form.reset();
    }
    if (noteT && edit) {
      getAllFacilitiesModal("all");
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id),
      };

      let customs = Array.isArray(_noteType?.custom)
        ? [..._noteType.custom]
        : [];

      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
      setSelectedFacility(data?.data?.fields?.["Facility Name"]);
    }
    if (opened) {
      getAllPatientsModal("all");
      getAllFacilitiesModal("active");
    }
  }, [noteT, opened]);

  useEffect(() => {
    if (edit) {
      setAiAssistantCardOpened(false);
      console.log('data?.data?.fields',data?.data?.fields);
      
      setFacilityDetials(data?.data?.fields?.["Facility Name"]);
      if (data?.data?.fields)
        Object.entries(data?.data?.fields)?.map((value) => {
          if (
            `${value[1]}`.split(":")?.length === 3 &&
            `${value[1]}`.split("-")?.length === 3
          ) {
            let date = new Date(value[1]);
            form?.setFieldValue(value[0], date);
          } else {
            form?.setFieldValue(value[0], value[1]);
          }
        });
    }

    if (NOTETYPE && opened) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE),
      };
      // let customs = _noteType ? [..._noteType?.custom] : [];
      let customs = Array.isArray(_noteType?.custom)
        ? [..._noteType.custom]
        : [];

      let indexOfPatient = customs?.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
    }
  }, [NOTETYPE, edit, opened]);

  useEffect(() => {
    if (opened) {
      if (profile?.user?.type === "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else if (profile?.user?.type !== "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else {
        form.setFieldValue("Staff Name", data?.data?.fields["Staff Name"]);
      }
      if (selectedPatient) {
        form.setFieldValue("Client Name", selectedPatient?.id);
      } else if (data?.data?.fields["Client Name"]) {
        form.setFieldValue("Client Name", data?.data?.fields["Client Name"]);
      } else if (data?.data?.fields["Patient Name"]) {
        form.setFieldValue("Client Name", data?.data?.fields["Patient Name"]);
      }
      if (selectedPatient && isBilling_Services) {
        form.setFieldValue("Provider", selectedPatient?.providerId[0]?.id);
      }
      if (selectedPatient && isBilling_Services) {
        form.setFieldValue(
          "Facility Name",
          selectedPatient?.facilityId?.map((item) => item?.id)
        );
      }
      let patientType = noteType?.custom?.find(
        (v) => v?.fieldType?.name === noteType_Client_Options
      );
      let patient = allPatients?.find((value) =>
        data?.data?.fields?.["Patient Name"] &&
        !data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Patient Name"]
          : data?.data?.fields?.["Patient Name"] &&
            data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Client Name"]
          : value?.id === data?.data?.fields[patientType?.field]
      );
      if (patient) {
        form.setFieldValue(noteType_Client, patient.id);
        setMedicationOptions(
          Array.isArray(patient?.form3) &&
            patient?.form3?.map((value) => {
              let { isPrescribed, id, ...rest } = value;
              return {
                label: value?.medicationName,
                value: objectToString({
                  ...filterNonNullFields(rest),
                  Prescribed: isPrescribed ? "Yes" : "No",
                }),
              };
            })
        );

        setSupportOptions(
          allPlans
            ?.find((v) => v?.client?.id === patient?.id)
            ?.outcomes?.map(({ id, ...rest }) => ({
              value: objectToString({
                ...filterNonNullFields(rest),
              }),
              label: rest.outcomeTitle,
            })) || []
        );
        setSelectedPatient(patient);
        setDescriptions(data?.data?.descriptions);

        setOutcomeNotes(data?.data?.descriptions?.map((_d) => _d?.description));
        setEssentialNotes(
          data?.data?.essentialSupport?.map((_e) => _e?.description)
        );
        setSupportPlan(data?.data?.supportPlan || "no");
        setEssentialSupportToggle(data?.data?.essentialSupportToggle || "no");
        setInterventionPlanToggle(data?.data?.interventionPlanToggle || "no");
        if (data?.data?.essentialSupport?.length) {
          setEssentialSupport(data?.data?.essentialSupport);
        }
        if (data?.data?.goals?.length) {
          setGoals(data?.data?.goals);
        }
      }
    }
    if (!view)
      noteType?.custom?.forEach((field) => {
        if (field?.fieldType?.name === "date" && !edit) {
          form?.setFieldValue(field.field, new Date());
        }
        if (field?.fieldType?.name === "time" && !edit) {
          const currentTime = new Date().toLocaleTimeString("en-US", {
            hour12: false,
          });
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let hours = new Date().getHours(),
              minutes = new Date().getMinutes();
            form?.setFieldValue(field.field, `${hours}:${minutes}`);
          } else {
            form?.setFieldValue(field.field, currentTime);
          }
        }
      });
  }, [noteType?.custom, opened]);

  useEffect(() => {
    if (userId) {
      handlePatientChange(userId, "Client Name");
    }
  }, [userId, allPatients]);

  useEffect(() => {
    setCurrentNote(noteType?.id);
  }, [noteType]);

  const initialValues = {};

  allNotesTypes?.ntypes?.custom?.map((value) => {
    initialValues[value?.field] = "";
  });

  const form = useForm({
    initialValues: (() => {
      const initialValues = { name: edit ? data?.data?.name : "" };
      noteType?.custom?.forEach((field) => {
        initialValues[field.field] = "";
      });

      return initialValues;
    })(),
  });

  useEffect(() => {
    const staffDetails = staff?.staffs?.find(
      (value) => String(value?.id) === String(form.values?.["Staff Name"])
    );
    setStaffDetials(staffDetails);
  }, [staff, form.values?.["Staff Name"]]);

  const validateFields = () => {
    const newErrors = {};
    descriptions?.forEach((medication, index) => {
      if (!medication?.outcomeNumber) {
        newErrors[index] = "Field is required";
      }
      if (!medication?.outcomeTitle) {
        newErrors[index] = "Field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEssentialSupport = () => {
    const errors = essentialSupport.map((item) => {
      const activityEmpty = !item.essentialActivityNumber;
      const typeEmpty = !item.essentialSupportType;
      return activityEmpty || typeEmpty;
    });
    setEssentialSupportErrors(errors);

    // Optionally return whether the form is valid
    return !errors.includes(true);
  };

  const noteDetails = form.values;

  const sendMessageToOpenAI = async (value) => {
    if (value === "behavior") {
      setBehaviorLoading(true);
    } else if (value === "response") {
      setResponseLoading(true);
    } else if (value === "plan") {
      setPlanLoading(true);
    } else {
      setLoading(true); // only when no value comes / doesn't match any case
    }

    // Conditionally construct Essential Support section
    let tempEssentialSupport = "";
    const selectedSupport = essentialSupport?.[essentialAccordion];

    if (essentialSupport) {
      const selectedActivity = selectedSupport?.activities?.find(
        (activity) =>
          String(activity?.id) ===
          String(selectedSupport?.essentialActivityNumber)
      );

      let howToSupportText = "";

      const howToSupport = selectedActivity?.howToSupport;

      if (Array.isArray(howToSupport)) {
        howToSupportText = howToSupport
          .map((item) => (typeof item === "string" ? item : item?.text))
          .filter(Boolean)
          .join(", ");
      } else if (typeof howToSupport === "string") {
        howToSupportText = howToSupport;
      }

      const supportStatement = selectedActivity?.supportStatement || "";

      tempEssentialSupport = `
    ${supportStatement}
    ${howToSupportText}
  `.trim();
    }

    // Conditionally construct Support Activities section
    let filteredDescriptions = descriptions?.filter(
      (item) => item?.details !== null
    );

    let supportActivitiesSection = "";
    const selectedItem = descriptions?.[openedAccordion];

    if (filteredDescriptions?.length > 0 && selectedItem?.details) {
      const { outcomeCategory, activities } = selectedItem.details;

      const activityNames =
        activities
          ?.map((activity) => activity?.supportActivity)
          .filter(Boolean)
          .join(", ") || "";

      const supportInstructionsText =
        activities
          ?.map((activity) => {
            const instr = activity?.supportInstructions;

            if (Array.isArray(instr)) {
              return instr
                .map((i) => (typeof i === "string" ? i : i?.text))
                .filter(Boolean)
                .join(", ");
            } else if (typeof instr === "string") {
              return instr;
            }
            return "";
          })
          .filter(Boolean)
          .join(", ") || "";

      supportActivitiesSection = `
    ${outcomeCategory || ""}
    ${activityNames}
    ${supportInstructionsText}
  `.trim();
    }

    // Conditionally construct Intervention Plan section
    let tempInterventionPlan = "";
    const selectedIntervention = goals?.[goalsAccordion];

    if (selectedIntervention?.goalActivities?.length) {
      tempInterventionPlan = selectedIntervention.goalActivities
        .map(
          (activity) =>
            `${" - Objectives : "}${
              activity?.objectives || ""
            }\n${" - Instructions : "}${
              activity?.Intervention_Instruction || ""
            }`
        )
        .join("\n\n"); // adds spacing between activities
    }

    let promptCommon = `
    Generate a {Note Type} for a {Facility Type} in {State} for the individual {Individual Name} using the {Staff Note} and {Support Activities}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Staff Note}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, reflective the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Staff Note} as the base and expand on it using information from the {Support Activities}. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the activities presented to the individual and the choice they made 
Staff involvement, support provided, and any interventions 
Observations of the individual’s behavior, engagement, emotional state, and any incidents
Do not add anything outside of the general scope of {Support Activities}. 
Do not add activities outside of the parameters of {Staff Note}.
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Staff Note} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Support Activities}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Do not make each response overly verbose. Make the word count less than or equal to 100 words.
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome” in the generated response.
Remember you are generating a note on behalf of a staff member. Do make things seem like the staff is trying to meet a list of expected activities (Do not over embellish). Make the language natural and come from the perspective that staffs only document the actions they took with that of their clients and corresponding responses.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Staff Note}”.

Use values defined below for the variables denoted in curly brackets

- State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Individual’s Name or Identifier: ${selectedPatient?.name || ""} 
- Support Activities : ${supportActivitiesSection || ""} ${
      tempEssentialSupport || ""
    }
- Staff Note = ${
      (noteDetails?.noteid?.name === "Progress Note" &&
        supportPlan === "yes") ||
      (noteDetails?.noteid?.name === "Essential Support Note" &&
        essentialSupportToggle === "yes")
        ? selectedItem?.description?.trim() ||
          selectedSupport?.description?.trim() ||
          ""
        : noteDetails?.Description?.trim() || ""
    }
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let polishNotePrompt = `
Generate a {Note Type} for a {Facility Type} in {State} for the individual {Individual Name} using the {Staff Note} and {Support Activities}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Staff Note}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, reflective the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Staff Note} as the base and expand on it using information from the {Support Activities}. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the activities presented to the individual and the choice they made 
Staff involvement, support provided, and any interventions 
Observations of the individual’s behavior, engagement, emotional state, and any incidents
Do not add anything outside of the general scope of the staff original note. . 
Do not add activities outside of the parameters of {Staff Note}.
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Staff Note} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Support Activities}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Do not make each response overly verbose. Make the word count less than or equal to 100 words.
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome” in the generated response.
Remember you are generating a note on behalf of a staff member. Do make things seem like the staff is trying to meet a list of expected activities (Do not over embellish). Make the language natural and come from the perspective that staffs only document the actions they took with that of their clients and corresponding responses.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Staff Note}”.

Use values defined below for the variables denoted in curly brackets

- State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Individual’s Name or Identifier: ${selectedPatient?.name || ""} 
- Support Activities : ${supportActivitiesSection || ""} ${
      tempEssentialSupport || ""
    }
- Staff Note = ${
      (noteDetails?.noteid?.name === "Progress Note" &&
        supportPlan === "yes") ||
      (noteDetails?.noteid?.name === "Essential Support Note" &&
        essentialSupportToggle === "yes")
        ? selectedItem?.description?.trim() ||
          selectedSupport?.description?.trim() ||
          ""
        : noteDetails?.Description?.trim() || ""
    }
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let rewriteNotePrompt = `
   Generate a {Note Type} for a {Facility Type} in {State} for the individual {Individual Name} using the {Staff Note} and {Support Activities}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Staff Note}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, reflective the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Staff Note} as the base and expand on it using information from the {Support Activities}. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the activities presented to the individual and the choice they made 
Staff involvement, support provided, and any interventions 
Observations of the individual’s behavior, engagement, emotional state, and any incidents
Do not add anything outside of the general scope of {Support Activities}. If more information is needed to complete the note, infer it only from what is written here: “{Support Activities}”.
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Staff Note} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Support Activities}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Do not make each response overly verbose. Make the word count less than or equal to 100 words.
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome” in the generated response.
Remember you are generating a note on behalf of a staff member. Do make things seem like the staff is trying to meet a list of expected activities (Do not over embellish). Make the language natural and come from the perspective that staffs only document the actions they took with that of their clients and corresponding responses.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Staff Note}”.

 Use values defined below for the variables denoted in curly brackets

 - State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Individual’s Name or Identifier: ${selectedPatient?.name || ""} 
- Support Activities : ${supportActivitiesSection || ""} ${
      tempEssentialSupport || ""
    }
- Staff Note = ${
      (noteDetails?.noteid?.name === "Progress Note" &&
        supportPlan === "yes") ||
      (noteDetails?.noteid?.name === "Essential Support Note" &&
        essentialSupportToggle === "yes")
        ? selectedItem?.description?.trim() ||
          selectedSupport?.description?.trim() ||
          ""
        : noteDetails?.Description?.trim() || ""
    }
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;
    let elaborateNotePrompt = `
Generate a {Note Type} for a {Facility Type} in {State} for the individual {Individual Name} using the {Staff Note} and {Support Activities}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Staff Note}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, reflective the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Staff Note} as the base and expand on it using information from the {Support Activities}. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the activities presented to the individual and the choice they made 
Staff involvement, support provided, and any interventions 
Observations of the individual’s behavior, engagement, emotional state, and any incidents
Do not add anything outside of the general scope of {Support Activities}. If more information is needed to complete the note, infer it only from what is written here: “{Support Activities}”.
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Staff Note} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Support Activities}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Make each response succinct and no more than 150 words unless the info provided really needs more than 150 words.
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome” in the generated response.
Remember you are generating a note on behalf of a staff member. Do add things that seem like the staff is trying to meet a list of expected activities. Make the language natural and come from the perspective that staffs only document the actions they took with that of their clients and corresponding responses.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Staff Note}”.
 
Use values defined below for the variables denoted in curly brackets

 - State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Individual’s Name or Identifier: ${selectedPatient?.name || ""} 
- Support Activities : ${supportActivitiesSection || ""} ${
      tempEssentialSupport || ""
    }
- Staff Note = ${
      (noteDetails?.noteid?.name === "Progress Note" &&
        supportPlan === "yes") ||
      (noteDetails?.noteid?.name === "Essential Support Note" &&
        essentialSupportToggle === "yes")
        ? selectedItem?.description?.trim() ||
          selectedSupport?.description?.trim() ||
          ""
        : noteDetails?.Description?.trim() || ""
    }
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let behaviorPrompt = `

{
  "Mood-Words": {
    "Positive": [      "Loved","Touched","Thankful","Sympathetic","Smart","Pleased","Satisfied","Relieved","Relaxed","Rejuvenated","Refreshed","Peaceful","Optimistic","Okay","Impressed","Hopeful","Happy","Grateful","Good","Accomplished","Accepted","Content","Chipper","Cheerful","Calm","Blissful","Amused","Enthralled","Jubilant","Energetic","Ecstatic","Curious","Bouncy"
    ],
    "Negative": [
"Stressed","Mad","Lonely","Uncomfortable","Pessimistic","Sick","Sad","Rejected","Morose","Moody","Melancholy","Listless","Lethargic","Lazy","Jealous","Irritated","Irate","Guilty","Grumpy","Groggy","Discontent","Gloomy","Frustrated","Exhausted","Enraged","Anxious","Annoyed","Angry","Drained","Disappointed","Depressed","Dark","Cynical","Alone","Aggravated","Crushed","Crappy","Cranky","Confused","Complacent","Cold","Bored","Blank","Blah","Bittersweet","Bewildered","Ashamed","Apathetic","Envious","Exanimate"
    ],
    "Neutral": [
"Surprised","Weird","Tired","Sleepy","Silly","Shocked","Rushed","Restless","Numb","Indifferent","Indescribable","Mellow","Naughty","Mischievous","Hot","Hungry","Full","Dorky","Ditzy","Geeky","Nerdy","Crazy","Not specified","Quixotic"
    ],
    "Playful": [
      "Giggly","Giddy","Flirty","Dirty","Devious","Mischievous","Dorky","Ditzy","Geeky","Naughty"
    ],
    "High-Energy": [
      "Hyper","High","Excited","Enraged","Predatory","Crazy","Dark","Drunk"
    ],
    "Low-Energy": [
      "Tired","Sleepy","Groggy","Exhausted","Drained","Lethargic","Listless","Recumbent"
    ]
  }
}

     Generate a behavior observation for an ${
       noteDetails?.noteid?.name || ""
     } for a {Facility Type} in {State} for the individual ${
      selectedPatient?.name || ""
    } using the {Behavior}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Behavior}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Behavior} as the base and edit or elaborate using words and phrases from the “Mood-Words” JSON file. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Do not add anything outside of the general scope of {Identified goals}, {Objective} and {Intervention}. Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Behavior} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Objective} and {Intervention}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Make each response succinct and no more than 100 words unless the info provided really needs more than 100 words. 
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome”, “Intervention”, “objectives”, “goals” in the generated response.
Remember you are generating a note on behalf of a staff member. Make the language natural and come from the perspective that staffs only document the actions and mood they witness their clients exhibit.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Behavior}”.

Use values defined below for the variables denoted in curly brackets
 ${tempInterventionPlan || ""}

  - Behavior = ${
    noteDetails?.noteid?.name === "Intervention Progress Note" &&
    interventionPlanToggle === "yes"
      ? selectedIntervention?.behaviorDescription?.trim() ||
        selectedIntervention?.behaviorDescription?.trim() ||
        ""
      : noteDetails?.Description?.trim() || ""
  }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    let responsePrompt = `

{
"Standard-Terms": {
"General Disposition": 
[ "attentive", "alert", "calm", "cheerful", "well-groomed", "coordinated", "animated", "spontaneous", "consistent",  "goal-directed", "well-mannered", "orderly", "deliberate", "persistent", "inquisitive", "variable motivation level", "adaptable", "transitions well", "willing to try again", "shows effort", "thinks before acting", "helpful"],
    "Communication": 
[ "makes appropriate eye contact", "understandable speech", "fluent", "engaging","articulate",  "thoughtful", "open", "asks for help", "cooperative" ],
    "Learning & Cognition": 
[ "stays on task", "uses trial and error approach","learns from doing", "notes detail", "applies him- or herself", "recognizes errors", "able to spell", "creatively spells", "memorizes words", "passive learner", "actively involved in learning", "requires information in a variety of modes" ],
    "Following Directions": 
[ "follows one-step directions", "follows two-step directions", "follows multi-step directions", "requires repetition of directions", "ignores distractions", "needs time to transition" ],
    "Support Needs": 
[ "accepts mistakes", "needs visual cues",  "requires auditory cues", "requires preparation for transition" ]
  }
}


   Generate a response observation for ${
     noteDetails?.noteid?.name || ""
   } for a {Facility Type} in {State} for the individual  ${
      selectedPatient?.name || ""
    } using {Intervention}’s. This is based of the Staff's/QMHP observations of their client to an intervention they enacted for the client.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Response}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, the generated note should preserve that voice while making it complete and appropriate for documentation. 
Use the {Response} as the base and edit or elaborate using words and phrases from the "Standard-Terms" JSON file. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Create a response for every {Intervention} mentioned.
The response has to be at least five sentences. 
Do not add anything outside of the general scope of {Identified goals}, {Objective} and {Intervention}. If more information is needed to complete the note, infer it only from what is written here: “{Identified goals}, {Objective} and {Intervention}”. 
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Response} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Objective} and {Intervention}” verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Keep clear, natural, error-free language.
Create a response for every {Intervention} mentioned. 
Each bullet-point response must be at least 150 words and may extend beyond 160 words if detail requires it. 
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome”, “Intervention”, “objectives”, “goals” in the generated response.
Remember you are generating a note on behalf of a staff member. You are creating a response based on the observation of the staff on the client's reaction to the intervention. Make the language natural and come from the perspective that staffs only document the response of their clients.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Response}”.

Use values defined below for the variables denoted in curly brackets
 ${tempInterventionPlan || ""}

  - Response = ${
    noteDetails?.noteid?.name === "Intervention Progress Note" &&
    interventionPlanToggle === "yes"
      ? selectedIntervention?.responseDescription?.trim() ||
        selectedIntervention?.responseDescription?.trim() ||
        ""
      : noteDetails?.Description?.trim() || ""
  }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    let planPrompt = `
   Generate a Plan for ${
     noteDetails?.noteid?.name || ""
   } for a {Facility Type} in {State} for the individual  ${
      selectedPatient?.name || ""
    }  using the {Plan} data, and {{Objective} and {Intervention}}.

    The plan must:
  Be an actual plan for the client's intervention.
Outline the next steps, such as scheduling the next appointment, assigning homework, making referrals, or any other actions for the client to do until the next time they see the QMHP/Staff.
Do not include an overview of what happened. Only generate notes for the plan for the day up until the next session. 
Be written entirely from the perspective of the staff as expressed in the {Plan}, using the same tone, phrasing, sentence structure, and level of formality. If the staff’s note is casual, the generated note should preserve that voice while making it complete and appropriate for documentation.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the plans presented to the individual and the choice they made if there is one 
Staff involvement or intervention with the planned support.
Observations of the individual’s behavior, engagement, emotional state, with the plan.
Do not add anything outside of the general scope of {Plan}”.
Do not rephrase or reframe the staff’s voice to sound more clinical, unless the original {Plan} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not include hyphens.
Do not use phrases from here “{Objective} and {Intervention}” verbatim.
Do not summarize the plan in the generated note. Do not use words and phrases like “Overall, in summary, at the end of the day”.
Create a response for every {Plan} mentioned.
Each bullet-point response must be between 50 and 70 words. Do not write fewer than 50 words or more than 70 words. Extend detail naturally to meet the minimum if needed, but do not exceed the maximum.
Do not mention things like the “Care Plan”, “Support Plan”, “Outcome”, “Intervention”, “objectives”, “goals” in the generated response.
Remember you are generating a note on behalf of a staff member. Do add things that seem like the staff is trying to meet a list of expected activities. Make the language natural and come from the perspective that staff/QMHP only documents the set and greed plan for the clients.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input “{Plan}”.

Use values defined below for the variables denoted in curly brackets

${tempInterventionPlan || ""}

   - Plan  = ${
     noteDetails?.noteid?.name === "Intervention Progress Note" &&
     interventionPlanToggle === "yes"
       ? selectedIntervention?.planDescription?.trim() ||
         selectedIntervention?.planDescription?.trim() ||
         ""
       : noteDetails?.Description?.trim() || ""
   }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    try {
      const finalPrompt =
        interventionPlanToggle === "yes" && value === "behavior"
          ? behaviorPrompt
          : value === "response"
          ? responsePrompt
          : value === "plan"
          ? planPrompt
          : value === "polishNotePrompt"
          ? polishNotePrompt
          : value === "rewriteNotePrompt"
          ? rewriteNotePrompt
          : value === "elaborateNotePrompt"
          ? elaborateNotePrompt
          : promptCommon;

      // : promptCommon;

      const aiReply = await generateAiNote(
        finalPrompt,
        profile?.user?.admin || profile?.user?.id
      );

      if (aiReply) {
        if (supportPlan === "yes") {
          setDescriptions((prev) => {
            const updated = [...prev];
            updated[openedAccordion] = {
              ...updated[openedAccordion],
              message: aiReply?.aiReply,
            };
            return updated;
          });
        } else if (essentialSupportToggle === "yes") {
          setEssentialSupport((prev) => {
            const updated = [...prev];
            updated[essentialAccordion] = {
              ...updated[essentialAccordion],
              message: aiReply?.aiReply,
            };
            return updated;
          });
        } else if (interventionPlanToggle === "yes") {
          setGoals((prev) => {
            const updated = [...prev];
            updated[goalsAccordion] = {
              ...updated[goalsAccordion],

              // message: aiReply,
              ...(value === "behavior"
                ? { behaviorAiReply: aiReply?.aiReply || "" }
                : value === "response"
                ? { responseAiReply: aiReply?.aiReply || "" }
                : value === "plan"
                ? { planAiReply: aiReply?.aiReply || "" }
                : { message: aiReply?.aiReply || "" }),
            };
            return updated;
          });
        } else {
          setMessages((prev) => {
            const updated = { ...prev, message: aiReply?.aiReply };
            return updated;
          });
        }
      }
    } catch (error) {
      if (value === "behavior") {
        setBehaviorLoading(false);
      } else if (value === "response") {
        setResponseLoading(false);
      } else if (value === "plan") {
        setPlanLoading(false);
      } else {
        setLoading(false); // only when no value comes / doesn't match any case
      }
    } finally {
      if (value === "behavior") {
        setBehaviorLoading(false);
      } else if (value === "response") {
        setResponseLoading(false);
      } else if (value === "plan") {
        setPlanLoading(false);
      } else {
        setLoading(false); // only when no value comes / doesn't match any case
      }
    }
  };

  const recordingTypeRef = useRef(recordingType);
  useEffect(() => {
    recordingTypeRef.current = recordingType;
  }, [recordingType]);

  const { startListening, stopListening } = useSpeechToText((transcript) => {
    form.setFieldValue("Description", transcript);

    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: transcript,
      };
      setDescriptions(updatedDescriptions);
    }

    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: transcript,
      };
      setEssentialSupport(updatedEssentialDes);
    } else if (recordingTypeRef.current === "behavior" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        behaviorDescription: transcript,
      };
      setGoals(updatedGoals);
    } else if (recordingTypeRef.current === "response" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        responseDescription: transcript,
      };
      setGoals(updatedGoals);
    } else if (recordingTypeRef.current === "plan" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        planDescription: transcript,
      };
      setGoals(updatedGoals);
    }
  });

  const startTimer = () => {
    setRecordingTime(0);
    timerRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  const handleMicStart = (type) => {
    if (type === "behavior") {
      setMicLabel(type);
      setRecordingType(type);
    } else if (type === "response") {
      setMicLabel(type);
      setRecordingType(type);
    } else if (type === "plan") {
      setMicLabel(type);
      setRecordingType(type);
    } else {
      setIsListening(true);
      setRecordingType(type);
    }
    startTimer();
    startListening();
  };

  const handleRecordingCancel = (type) => {
    form.setFieldValue("Description", "");
    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: "",
      };
      setDescriptions(updatedDescriptions);
    }
    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: "",
      };
      setEssentialSupport(updatedEssentialDes);
    }
    if (type === "behavior") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        behaviorDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    } else if (type === "response") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        responseDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    } else if (type === "plan") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        planDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    }
    stopListening();
    stopTimer();
    setRecordingTime(0);
    setIsListening(false);
  };

  const handleRecordingConfirm = (type) => {
    stopListening();
    stopTimer();
    if (type === "behavior") {
      setMicLabel(false);
    } else if (type === "response") {
      setMicLabel(false);
    } else if (type === "plan") {
      setMicLabel(false);
    } else {
      setIsListening(false);
    }
  };

  let isAiAccess =
    !profile?.user?.role && !profile?.user?.type
      ? true
      : facilityDetials &&
        (facilityDetials?.skaiAccess === true ||
          facilityDetials?.skaiAccess === undefined) &&
        staffDetials &&
        (staffDetials?.permissions?.aiAccess === true ||
          !staffDetials?.permissions);

  const handleRedo = (type) => {
    form.setFieldValue("Description", "");
    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: "",
      };
      setDescriptions(updatedDescriptions);
    }
    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: "",
      };
      setEssentialSupport(updatedEssentialDes);
    }
    if (type === "behavior") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        behaviorDescription: "",
      };
      setGoals(updatedGoalDes);
    } else if (type === "response") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        responseDescription: "",
      };
      setGoals(updatedGoalDes);
    } else if (type === "plan") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        planDescription: "",
      };
      setGoals(updatedGoalDes);
    }

    stopListening();
    stopTimer();
    setRecordingTime(0);
    startTimer();
    startListening();
  };
  const isAdmin = profile?.user?.role === "admin" || !profile?.user?.type;

  const ReturnFormItem = (data, index, textArea = "") => {
    let { field: name, fieldType, placeholder, viewOnly } = data;
    if (
      textArea &&
      supportPlan !== "yes" &&
      essentialSupportToggle === "no" &&
      interventionPlanToggle === "no" &&
      data?.field === "Description" &&
      (noteType?.name === "Progress Note" ||
        noteType?.id === Essential_Support_Note)
    ) {
      return (
        <Box>
          <Box>
            <Textarea
              key={index}
              radius="md"
              maxRows={10}
              label="Description"
              minRows={10}
              placeholder={placeholder || "Enter a description..."}
              autosize={view || (viewOnly ? true : false) ? true : false}
              className={classes.essentialDiscriptionArea}
              {...form.getInputProps(name)}
              readOnly={view || (viewOnly ? true : false)}
            />
            {!view && (
              <>
                <AiAssistantChatCard
                  open={aiAssistantCardOpened}
                  handleAiAssistantSubmit={handleAiAssistantSubmit}
                  form={form}
                  descriptions={descriptions}
                  messages={messages?.message || []}
                  sendMessageToOpenAI={sendMessageToOpenAI}
                  loading={loading}
                  messageValue={messageValue}
                  formErrors={formErrors}
                  setAiAssistantCardOpened={setAiAssistantCardOpened}
                  // facilityDetials={facilityDetials}
                  // selectedPatient={selectedPatient}
                  // setMessages={setMessages}
                  // openedAccordion={openedAccordion}
                  // essentialAccordion={essentialAccordion}
                  // essentialSupport={essentialSupport}
                />
                {!aiAssistantCardOpened && isAiAccess && (
                  <>
                    <Flex
                      direction="column"
                      px={19}
                      bg="#FAFAFA"
                      py={8}
                      sx={{
                        border: "1px solid #D0D5DD",
                        borderRadius: "0px 0px 8px 8px",
                      }}
                    >
                      <Flex justify="space-between" align="center" gap={12}>
                        <Flex align={"center"} gap={8}>
                          <Text ff={"inter"} fw={500} fz={"md"}>
                            Credit Balance:{" "}
                          </Text>
                          <Text ff={"inter"} fw={500} fz={"md"}>
                            {/* {existingRecord?.active && existingRecord?.paid */}
                            {existingRecord?.planType === "monthly-subscription" || existingRecord?.packageType === "Gold"
                              ? "Unlimited"
                              : Number(existingRecord?.adminTotalTokens)}
                          </Text>
                        </Flex>
                        <Flex gap={8} align={"center"}>
                          <UnstyledButton
                            disabled={
                              view ||
                              (existingRecord?.active === false &&
                                existingRecord?.paid === false)
                            }
                            style={{
                              cursor:
                                view ||
                                (existingRecord?.active === false &&
                                  existingRecord?.paid === false)
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            onClick={() => {
                              handleMicStart("essential");
                            }}
                          >
                            <MicAiSvg
                              color={
                                view ||
                                (existingRecord?.active === false &&
                                  existingRecord?.paid === false)
                                  ? "#A0A0A0"
                                  : "#000"
                              }
                            />
                          </UnstyledButton>
                          <UnstyledButton
                            disabled={
                              view ||
                              form.values.Description === "" ||
                              !form.values.Description
                            }
                            style={{
                              cursor:
                                view ||
                                form.values.Description === "" ||
                                !form.values.Description
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            // onClick={handleAiAssistantSubmit}
                            onClick={() => {
                              setShowAiButtons(true);
                            }}
                          >
                            <AutoFillSvg
                              color={
                                view ||
                                form.values.Description === "" ||
                                !form.values.Description
                                  ? "#A0A0A0"
                                  : "#000"
                              }
                            />
                          </UnstyledButton>
                        </Flex>
                      </Flex>
                      {showAiButtons && (
                        <>
                          <Divider my="5px" />
                          <AiActionButtons
                            handleAiAssistantSubmit={handleAiAssistantSubmit}
                            buttonData={buttonData}
                          />
                        </>
                        // <Flex
                        //   justify="flex-end"
                        //   align="center"
                        //   mt="xs"
                        //   gap="sm"
                        // >
                        //   <Button
                        //     variant="outline"
                        //     onClick={() =>
                        //       handleAiAssistantSubmit("rewriteNotePrompt")
                        //     }
                        //   >
                        //     Rewrite my note
                        //   </Button>
                        //   <Button
                        //     onClick={() =>
                        //       handleAiAssistantSubmit("polishNotePrompt")
                        //     }
                        //   >
                        //     Polish my note
                        //   </Button>
                        // </Flex>
                      )}
                    </Flex>
                  </>
                )}
              </>
            )}
          </Box>
          <RecordingControls
            isListening={isListening}
            recordingTime={recordingTime}
            onRedo={handleRedo}
            onCancel={handleRecordingCancel}
            onConfirm={handleRecordingConfirm}
            classes={classes}
          />
        </Box>
      );
    }

    let obj = {
      string: (
        <TextInput
          size="md"
          radius="md"
          id="reason"
          key={index}
          type="text"
          label={name}
          className={classes.datePicker}
          // className={classes.essentialDiscriptionArea}
          {...form.getInputProps(name)}
          disabled={view || (viewOnly ? true : false)}
          placeholder={placeholder || `Enter response`}
        />
      ),
      "text area": (
        <>
          <Textarea
            id={
              data?.field === "Description"
                ? "enter-description"
                : data?.field === "Medication"
                ? "enter-medication"
                : "enter-note"
            }
            key={index}
            label={name}
            minRows={view || (viewOnly ? true : false) ? 7 : 7}
            maxRows={view || (viewOnly ? true : false) ? 15 : 15}
            autosize={view || (viewOnly ? true : false) ? true : false}
            placeholder={placeholder || `Enter response`}
            className={`${classes.essentialDiscriptionArea} ${
              view || (viewOnly ? true : false) ? classes.disabledTextarea : ""
            }`}
            radius="md"
            {...form.getInputProps(name)}
            readOnly={view || viewOnly ? true : false}
            // readOnly={view}
          />

          {data?.field === "Description" ? (
            <>
              {!view && (
                <>
                  <AiAssistantChatCard
                    open={aiAssistantCardOpened}
                    handleAiAssistantSubmit={handleAiAssistantSubmit}
                    form={form}
                    descriptions={descriptions}
                    staffDetials={staffDetials}
                    messages={messages?.message || []}
                    sendMessageToOpenAI={sendMessageToOpenAI}
                    loading={loading}
                    setAiAssistantCardOpened={setAiAssistantCardOpened}
                  />
                  {!aiAssistantCardOpened && isAiAccess && (
                    <Flex
                      px={19}
                      bg={"#FAFAFA"}
                      py={8}
                      justify="space-between"
                      align={"center"}
                      gap={12}
                      sx={{
                        border: "1px solid #D0D5DD",
                        borderRadius: "0px 0px 8px 8px",
                      }}
                    >
                      <Flex align={"center"} gap={8}>
                        <Text ff={"inter"} fw={500} fz={"md"}>
                          Credit Balance:{" "}
                        </Text>
                        <Text ff={"inter"} fw={500} fz={"md"}>
                          {/* {existingRecord?.active && existingRecord?.paid */}
                          {existingRecord?.planType === "monthly-subscription" || existingRecord?.packageType === "Gold"
                            ? "Unlimited"
                            : Number(existingRecord?.adminTotalTokens)}
                        </Text>
                      </Flex>

                      <Flex align={"center"} gap={8}>
                        <UnstyledButton
                          disabled={
                            view ||
                            (existingRecord?.active === false &&
                              existingRecord?.paid === false)
                          }
                          style={{
                            cursor:
                              view ||
                              (existingRecord?.active === false &&
                                existingRecord?.paid === false)
                                ? "not-allowed"
                                : "pointer",
                          }}
                          onClick={() => {
                            handleMicStart("essential");
                          }}
                        >
                          <MicAiSvg
                            color={
                              view ||
                              (existingRecord?.active === false &&
                                existingRecord?.paid === false)
                                ? "#A0A0A0"
                                : "#000"
                            }
                          />
                        </UnstyledButton>
                        <UnstyledButton
                          disabled={
                            view ||
                            (supportPlan === "no"
                              ? !form?.values?.Description?.trim()
                              : descriptions?.some(
                                  (item) => !item?.description?.trim()
                                ))
                          }
                          style={{
                            cursor:
                              view ||
                              (supportPlan === "no"
                                ? !form?.values?.Description?.trim()
                                : descriptions?.some(
                                    (item) => !item?.description?.trim()
                                  ))
                                ? "not-allowed"
                                : "pointer",
                          }}
                          onClick={() =>
                            handleAiAssistantSubmit("custom-description")
                          }
                        >
                          <AutoFillSvg
                            color={
                              view ||
                              (supportPlan === "no"
                                ? !form?.values?.Description?.trim()
                                : descriptions?.some(
                                    (item) => !item?.description?.trim()
                                  ))
                                ? "#A0A0A0"
                                : "#000"
                            }
                          />
                        </UnstyledButton>
                      </Flex>
                    </Flex>
                  )}
                </>
              )}
              <RecordingControls
                isListening={isListening}
                recordingTime={recordingTime}
                onRedo={handleRedo}
                onCancel={handleRecordingCancel}
                onConfirm={handleRecordingConfirm}
                classes={classes}
              />
              {/* {isListening && (
            <Box className={classes.waveSection}>
              <Box className={classes.wave}>
                <WaveformVisualizer isActive={isListening} />
              </Box>

              <Box className={classes.waveButtons}>
                <Button
                  variant="light"
                  color="gray"
                  radius={"xl"}
                  size="xs"
                  onClick={handleRedo}
                >
                  <Flex align={"center"} gap={5}>
                    <RecordingRedoSvg />
                    <Text c={"#525252"}>Redo</Text>
                  </Flex>
                </Button>
                <Flex align={"center"} gap={5}>
                  <UnstyledButton
                    variant="outline"
                    color="gray"
                    onClick={handleRecordingCancel}
                  >
                    <RecordingCancelSvg />
                  </UnstyledButton>
                  <Text size="sm" mt="sm" color="dimmed" pb={15}>
                    {formatTime(recordingTime)}
                  </Text>
                  <UnstyledButton onClick={handleRecordingConfirm}>
                    <RecordingTickMarkSvg />
                  </UnstyledButton>
                </Flex>
              </Box>
            </Box>
          )} */}
            </>
          ) : null}
        </>
      ),

      number: (
        <Flex direction={"column"}>
          {isBilling_Services ? (
            <>
              <TextInput
                size="md"
                radius="md"
                key={index}
                label={name}
                type="number"
                className={classes.input}
                {...form.getInputProps(name)}
                disabled={view || (viewOnly ? true : false) || !serviceNumber}
                placeholder={placeholder || `Enter response`}
              />
              {isBilling_Services && (
                <Text fz={12} fs="italic" c={"#ccc"}>
                  Approved Units: {serviceNumber?.servicenumber}
                </Text>
              )}
            </>
          ) : (
            <TextInput
              size="md"
              radius="md"
              key={index}
              label={name}
              type="number"
              className={classes.input}
              {...form.getInputProps(name)}
              disabled={view || (viewOnly ? true : false)}
              placeholder={placeholder || `Enter response`}
            />
          )}
        </Flex>
      ),

      time: (
        <TimeInput
          size="md"
          radius="md"
          label={name}
          key={index}
          ref={ref}
          placeholder={`Select ${name}`}
          className={classes.datePicker}
          icon={
            <img
              style={{ width: "20px" }}
              src={"/assets/images/clock.png"}
              alt="Icon"
            />
          }
          {...form.getInputProps(name)}
          onChange={(e) => {
            const isSafari = /^((?!chrome|android).)*safari/i.test(
              navigator.userAgent
            );
            const datetime = new Date(e.target.value).toLocaleTimeString(
              "en-US",
              { hour12: false }
            );
            let time = e.target.value.split(":")?.slice(0, 2)?.join(":");
            isSafari
              ? form.setFieldValue(name, time)
              : form.setFieldValue(name, e.target.value);
          }}
          disabled={view || (viewOnly ? true : false)}
        />
      ),
      date: (
        <DateInput
          size="md"
          radius="md"
          key={index}
          label={name}
          id="date-click"
          icon={<DateSvg />}
          className={classes.datePicker}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          disabled={view || (viewOnly ? true : false)}
          maxDate={isBilling_Services ? today : null}
        />
      ),
      Clients: (
        <Select
          size="md"
          radius="md"
          searchable
          label={name}
          className={classes.select}
          rightSection={icon}
          defaultValue={form?.getInputProps(name)}
          id={"client-name-note"}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          value={selectedPatient?.id}
          required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          data={allPatients
            ?.filter((_p) => _p?.active === true && _p?.deleted === false)
            ?.map((opt) => ({
              value: opt?.id,
              label: opt?.name,
            }))}
          // data={
          //   clientDetails ?  [
          //     {
          //       value: clientDetails?.id,
          //       label: clientDetails?.name,
          //     },
          //   ] : (
          //     allAssignPatients
          //     ?.filter((_p) => _p?.active === true && _p?.deleted === false)
          //     ?.map((opt) => ({
          //       value: opt?.id,
          //       label: opt?.name,
          //     }))
          //   )
          // }
          // // data={}

          disabled={view || edit || (viewOnly || userId ? true : false)}
        />
      ),
      Provider: (
        <Select
          size="md"
          radius={"md"}
          className={classes.select}
          searchable
          label={name}
          rightSection={icon}
          defaultValue={form?.getInputProps(name)}
          id={"client-name-note"}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          onChange={(v) => handlePatientChange(v, name)}
          value={selectedPatient?.providerId?.[0]?.id || ""}
          data={
            selectedPatient?.providerId?.length > 0
              ? selectedPatient?.providerId?.map((_p) => ({
                  value: _p?.id,
                  label: _p?.name,
                }))
              : []
          }
          disabled={true}
        />
      ),
      Facilities: (
        <Select
          size="md"
          radius="md"
          className={classes.select}
          searchable
          label={name}
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          onChange={(e) => handleFacilityChange(e, name)}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          required={viewOnly || userId ? false : true}
          data={getOptions(
            "Facilities",
            noteType?.custom,
            undefined,
            view ? true : false
          )?.map((opt) => {
            if (Array.isArray(selectedPatient?.facilityId)) {
              if (
                selectedPatient?.facilityId?.find(
                  (fac) => fac?.id == opt?.value
                )
              ) {
                return opt;
              } else {
                return { ...opt, disabled: true };
              }
            } else {
              if (selectedPatient?.facilityId?.id == opt?.value) {
                return opt;
              } else {
                return { ...opt, disabled: true };
              }
            }
          })}
        />
      ),
      Staff: (
        <Box className={classes.staffContainer}>
          {/* <Text fw={500}>{name}:</Text> */}
          {view ? (
            <Select
              width={"100%"}
              size="md"
              className={classes.select}
              radius="md"
              rightSection={icon}
              label={name}
              rightSectionPointerEvents="none"
              data={getOptions("Staff All", noteType?.custom)}
              placeholder={`Select ${name}`}
              searchable
              defaultValue={form?.getInputProps(name)}
              {...form.getInputProps(name)}
              disabled={true}
            />
          ) : edit ? (
            <Box className={classes.staffOnEdit}>
              <Grid
                gutter={10}
                // cols={isMobileScreen ? 1 : 3}
                className={classes.mwd}
                sx={{
                  paddingBottom: 30,
                }}
              >
                {!isAdmin && (
                  <Grid.Col span={12}>
                    {/* for staff only */}
                    <Select
                      width={"100%"}
                      size="md"
                      className={classes.select}
                      radius="md"
                      label={name}
                      rightSection={icon}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff All", noteType?.custom)}
                      placeholder={`Select ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={true}
                    />
                  </Grid.Col>
                )}

                {isAdmin && (
                  <>
                    {/* for both main Admin & role with Admin */}
                    <Grid.Col span={isMobileScreen ? 12 : 6}>
                      <Select
                        width={"100%"}
                        size="md"
                        className={classes.select}
                        radius="md"
                        label={name}
                        rightSection={icon}
                        rightSectionPointerEvents="none"
                        data={getOptions("Staff All", noteType?.custom)}
                        placeholder={`Select ${name}`}
                        searchable
                        defaultValue={form?.getInputProps(name)}
                        {...form.getInputProps(name)}
                        disabled={true}
                      />
                    </Grid.Col>

                    <Grid.Col span={isMobileScreen ? 12 : 6}>
                      <Select
                        size="md"
                        radius="md"
                        label={name}
                        rightSection={icon}
                        className={classes.select}
                        rightSectionPointerEvents="none"
                        data={getOptions("Staff", noteType?.custom)}
                        placeholder={`Select New ${name}`}
                        searchable
                        defaultValue={form?.getInputProps(name)}
                        {...form.getInputProps(name)}
                        disabled={
                          view ||
                          (viewOnly
                            ? true
                            : !edit && profile?.user?.type === "staff"
                            ? true
                            : false)
                        }
                      />
                    </Grid.Col>
                  </>
                )}

                {/* <Grid.Col span={isMobileScreen ? 12 : 6}>
                    <Select
                      width={"100%"}
                      size="md"
                      className={classes.select}
                      radius="md"
                      label={name}
                      rightSection={icon}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff All", noteType?.custom)}
                      placeholder={`Select ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={true}
                    />
                  </Grid.Col>
                  <Grid.Col span={isMobileScreen ? 12 : 6}>
                    <Select
                      size="md"
                      radius="md"
                      label={name}
                      rightSection={icon}
                      className={classes.select}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff", noteType?.custom)}
                      placeholder={`Select New ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={
                        view ||
                        (viewOnly
                          ? true
                          : !edit &&
                            profile?.user?.type === "staff" &&
                            profile?.user?.role !== "admin"
                          ? true
                          : false)
                      }
                      // disabled={
                      //   view ||
                      //   (viewOnly
                      //     ? true
                      //     : !edit && profile?.user?.type === "staff"
                      //     ? true
                      //     : false)
                      // }
                    />
                  </Grid.Col> */}
              </Grid>
            </Box>
          ) : (
            <Select
              size="md"
              radius="md"
              label={name}
              className={classes.select}
              rightSection={icon}
              rightSectionPointerEvents="none"
              data={getOptions("Staff", noteType?.custom)}
              placeholder={`Select ${name}`}
              searchable
              defaultValue={form?.getInputProps(name)}
              {...form.getInputProps(name)}
              disabled={
                view ||
                (viewOnly
                  ? true
                  : !edit &&
                    profile?.user?.type === "staff" &&
                    profile?.user?.role !== "admin"
                  ? true
                  : false)
              }
              // disabled={
              //   view ||
              //   (viewOnly
              //     ? true
              //     : !edit && profile?.user?.type === "staff"
              //     ? true
              //     : false)
              // }
            />
          )}
        </Box>
      ),
      "Facility Types": (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.select}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Facility Types", noteType?.custom)}
        />
      ),
      Other: (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Other", noteType?.custom, name)}
        />
      ),
      "Multiple Choice": (
        <Checkbox.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("multiple choices", noteType?.custom, name)?.map(
            (option) => (
              <Checkbox
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                disabled={view || (viewOnly ? true : false)}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Checkbox.Group>
      ),
      "Single Choice": (
        <Radio.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("single choice", noteType?.custom, name)?.map(
            (option) => (
              <Radio
                disabled={view || (viewOnly ? true : false)}
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Radio.Group>
      ),
      Dropdown: (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("dropdown", noteType?.custom, name)}
        />
      ),
      "Medication Records": (
        <Group align="flex-end">
          <Select
            rightSection={icon}
            size="xs"
            searchable
            label={name}
            data={medicationOptions}
            className={classes.select}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={view || (viewOnly ? true : false)}
          />
          <Popover
            shadow="md"
            width={300}
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "Support Plan": (
        <Group align="flex-end">
          <Select
            size="xs"
            searchable
            label={name}
            data={supportOptions}
            className={classes.select}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={view || (viewOnly ? true : false)}
          />
          <Popover
            width={300}
            shadow="md"
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "level of need": (
        <Select
          size="md"
          radius="md"
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("level of need", noteType?.custom)}
        />
      ),
    };

    if (
      (essentialSupportToggle === "yes" || interventionPlanToggle === "yes") &&
      name === "Description" &&
      textArea
    )
      return null;
    else if (!textArea && fieldType?.name != "text area")
      return obj[fieldType?.name];
    else if (textArea && fieldType?.name === "text area")
      return obj[fieldType?.name];
    else return null;
    // return obj[fieldType?.name]
  };

  const showRadioButtons =
    (noteType?.name === "Incident Note" &&
      noteType?.name === "Medication Note") ||
    noteType?.name === "Progress Note" ||
    noteType?.custom?.find((_c) => _c?.field === "Support Plan");

  const handleToggleChange = (e, type) => {
    setShowAiButtons(false);
    setEssentialSupportErrors([]);

    if (type === "interventionPlan") {
      setInterventionPlanToggle(e);
    } else {
      setEssentialSupportToggle(e);
      setAiAssistantCardOpened(false);
      setMessages([]);
      form.setFieldValue("Description", "");
    }
  };

  const validatePromptFields = () => {
    const errors = {};

    if (!selectedPatient?.name) {
      errors.name = "Client name is required.";
    }

    // const hasNoteDescription = !!noteDetails?.Description;
    // const hasDescriptionsList = descriptions?.some(
    //   (item) => !!item?.description
    // );
    // const hasSupportDescription = !!essentialSupport?.description;

    // if (!hasNoteDescription && !hasDescriptionsList && !hasSupportDescription) {
    //   errors.description = "Description is required.";
    // }


    

    if (!edit && !facilityDetials?.name) {
      errors.facility = "Facility Name is required.";
    }

      if (edit && !facilityDetials) {
      errors.facility = "Facility Name is required.";
    }

    return errors;
  };
  const handleAiAssistantSubmit = (values) => {
    if (values !== "custom-description") {
      const errors = validatePromptFields();
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
    }
    setFormErrors({});
    // if (!messageValue) return;
    // setVisible(false);
    // sendMessageToOpenAI(messageValue);
    setMessageValue("");
    // if(tokensUsage)
    checkTokenUsageWarning(existingRecord, values);
  };

  useEffect(() => {
    form.setFieldValue("noteid", noteType);
  }, [noteType]);

  const noteTypeApproval = noteType?.adminApprovals?.find(
    (item) => item?.admin === profile?.user?.admin
  )
    ? noteType?.adminApprovals?.find(
        (item) => item?.admin === profile?.user?.admin
      )?.status
    : noteType?.approvalRequired;

  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff && staff === form.values?.["Staff Name"]) ||
      (admin && admin === form.values?.["Staff Name"])
  );

  const buttonData = [
    {
      label: "Elaborate",
      prompt: "elaborateNotePrompt",
      icon: "/assets/images/ElaborateAiImg.png",
    },
    {
      label: "Rewrite",
      prompt: "rewriteNotePrompt",
      icon: "/assets/images/RewriteNoteAiImg.png",
    },
    {
      label: "Polish",
      prompt: "polishNotePrompt",
      icon: <PolishNoteAiSvg />,
    },
  ];

  // const isStaffWithoutApproval =
  // profile?.user?.type === "staff" && !newAdminApproval;

  return (
    <>
      {/* -----> Pending Modal <----- */}

      {noteType && (
        <CustomModal
          modalState={pendingModal}
          modalTopImg={pendingModalIcon}
          modalTitle={
            noteTypeApproval ? "Pending Approval" : "Note Successfully Saved"
          }
          modalTextOne={
            noteTypeApproval
              ? `The note has been submitted for admin approval.`
              : null
          }
          modalTextTwo={
            noteTypeApproval
              ? `Please check back to see if it was approved or`
              : null
          }
          modalTextThree={noteTypeApproval ? "denied." : null}
          closeModal={setPendingModal}
          colorOne={"yellow"}
          variantOne={"filled"}
          btnTextOne="OK"
          noteType={noteType}
          setNoteType={setNoteType}
        />
      )}

      {/* -----> Note Editid <----- */}

      <CustomModal
        modalState={editModal}
        modalTopImg={pendingModalIcon}
        modalTitle={"Note Edited"}
        modalText={"Note has been edited successfully."}
        closeModal={setEditModal}
        colorOne={"yellow"}
        variantOne={"filled"}
        btnTextOne="OK"
      />

      <div style={{ overflowX: "auto" }}>
        <div>
          <Drawer
            centered
            shadow="md"
            size={700}
            zIndex={1000}
            opened={opened}
            title={view ? "View" : edit ? "Edit" : "Add Note"}
            overlayProps={{ blur: 3 }}
            className={classes.mymodal}
            closeOnClickOutside={false}
            position="right"
            onClose={() => {
              resetForm();
              setSelectedPatient(null);
              setNoteType(null);
              setOpenedAccordion("0");
              setEssentialAccordion("0");
              setFacilityDetials(null);
              setStaffDetials(null);
              // setView(false);
            }}
          >
            <form
              onSubmit={form?.onSubmit((values) => onSave(values))}
              className={classes.formStyling}
            >
              <NoteTypeComp
                edit={edit}
                view={view}
                noteType={noteType}
                setNoteType={setNoteType}
                // setSelectedNote={setSelectedNote}
                className={classes.noteType}
                setEssentialSupportToggle={setEssentialSupportToggle}
                setMessages={setMessages}
                setAiAssistantCardOpened={setAiAssistantCardOpened}
                handleRecordingCancel={handleRecordingCancel}
                setShowAiButtons={setShowAiButtons}
              />
              {noteType && (
                <Box>
                  <Text
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 600,
                      margin: "16px 0px",
                      color: "#171717",
                    }}
                  >
                    <span>{`${view ? "View" : edit ? "Edit" : "Add"} ${
                      noteType?.name
                    }`}</span>
                  </Text>
                  <Box className={classes.detailsForm}>
                    <Grid mt={5}>
                      {/* -----> Level of need <----- */}
                      {noteType?.custom?.filter(
                        (value) => value?.field === "Level of Need"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Level of Need")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Staff Name <----- */}
                      {noteType?.custom?.filter(
                        (value) => value?.field === "Staff Name"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Staff Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Client Name <----- */}

                      {noteType?.custom?.filter(
                        (value) => value?.field === "Client Name"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Client Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Billing <----- */}

                      {isBilling_Services && (
                        <>
                          {/* -----> Provider <----- */}

                          <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter((value) => value.field === "Provider")
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col>

                          {/* -----> Service (Unit Type: Days) <----- */}

                          <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Select
                              size="md"
                              searchable
                              label={"Service (Unit Type: Days)"}
                              radius={"md"}
                              rightSection={icon}
                              // defaultValue={userId}
                              id={"client-name-note"}
                              className={`${classes.select} ${classes.selectBG}`}
                              {...form.getInputProps("Service Type")}
                              placeholder={`Select Service (Unit Type: Days)`}
                              rightSectionPointerEvents="none"
                              required={view || userId ? false : true}
                              onChange={(v) => {
                                handlePatientChange(v, "Service Type");
                              }}
                              data={
                                selectedPatient?.form1?.services?.length > 0
                                  ? selectedPatient?.form1?.services?.map(
                                      (val) => ({
                                        value: val?.servicenumber,
                                        label: val?.servicetitle,
                                      })
                                    )
                                  : []
                              }
                              disabled={view}
                            />
                          </Grid.Col>

                          {/* -----> Unit/Day/Hours <----- */}

                          <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter(
                                (value) => value.field === "Unit/Day/Hours"
                              )
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col>

                          {/* -----> Service Date <----- */}

                          {/* <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter(
                                (value) => value.field === "Service Date"
                              )
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col> */}
                        </>
                      )}

                      {currentNote !== Billing_Services_Note &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Facility Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Date <----- */}
                      {noteType?.custom?.filter(
                        (value) => value.field === "Date"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value.fieldType?.name?.toLowerCase() === "date"
                          )
                          // ?.filter((value) => value.field === "Date")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Time <----- */}
                      {noteType?.custom?.filter(
                        // (value) => value.field === "Time"
                        (value) => value.fieldType?.name === "time"
                      ) &&
                        noteType?.custom
                          // ?.filter((value) => value.field === "Time")
                          ?.filter((value) => value.fieldType?.name === "time")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Shift <----- */}
                      {noteType?.general === true &&
                        noteType?.custom?.filter(
                          (value) => value.field === "Shift"
                        ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Shift")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {isEssentialSupport && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Essential Support</Text>

                            <Tooltip
                              label="Select Facility Name First"
                              placement="bottom"
                              withArrow
                              trigger="hover"
                              disabled={selectedFacility}
                            >
                              <Radio.Group
                                size="xs"
                                value={essentialSupportToggle}
                                name="useSupportPlan"
                                onChange={(value) => {
                                  handleToggleChange(value, "essentialSupport");
                                }}
                                className="radioGroupStyling"
                              >
                                <Group>
                                  <Radio
                                    value="yes"
                                    label="Yes"
                                    id="check-yes"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                  <Radio
                                    value="no"
                                    label="No"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                </Group>
                              </Radio.Group>
                            </Tooltip>
                          </Box>
                        </Grid.Col>
                      )}

                      {isIntervention_Progress_Note && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Intervention plan</Text>

                            <Tooltip
                              label="Select Facility Name First"
                              placement="bottom"
                              withArrow
                              trigger="hover"
                              disabled={selectedFacility}
                            >
                              <Radio.Group
                                size="xs"
                                value={interventionPlanToggle}
                                name="useInterventionPlan"
                                onChange={(value) => {
                                  handleToggleChange(value, "interventionPlan");
                                }}
                                className="radioGroupStyling"
                              >
                                <Group>
                                  <Radio
                                    value="yes"
                                    label="Yes"
                                    id="check-yes"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                  <Radio
                                    value="no"
                                    label="No"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                </Group>
                              </Radio.Group>
                            </Tooltip>
                          </Box>
                        </Grid.Col>
                      )}

                      {showRadioButtons && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Support Plan</Text>
                            <Radio.Group
                              size="xs"
                              value={supportPlan}
                              name="useSupportPlan"
                              onChange={handleSupportPlanChange}
                              variant="outline"
                              className="radioGroupStyling"
                            >
                              <Group>
                                <Radio
                                  value="yes"
                                  label="Yes"
                                  id="check-yes"
                                  color="gray"
                                  disabled={view}
                                  variant="outline"
                                />
                                <Radio
                                  value="no"
                                  label="No"
                                  color="gray"
                                  disabled={view}
                                  variant="outline"
                                />
                              </Group>
                            </Radio.Group>
                          </Box>
                        </Grid.Col>
                      )}

                      {/* Custom Field Time */}
                      {/* {noteType?.custom?.filter(
                        (value) =>
                          value?.field_type === "Custom Field" &&
                          value.fieldType?.name === "time"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "time"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))} */}

                      {/* Custom Field Dropdown */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) => value.fieldType?.name === "Dropdown"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) => value.fieldType?.name === "Dropdown"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Number */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name === "number"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "number"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Other */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name?.toLowerCase() === "other"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name?.toLowerCase() === "other"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Multiple Choice */}
                      {noteType?.custom?.filter(
                        (value) => value.fieldType?.name === "Multiple Choice"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value.fieldType?.name === "Multiple Choice"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Single Choice */}
                      {noteType?.custom?.filter(
                        (value) => value.fieldType?.name === "Single Choice"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) => value.fieldType?.name === "Single Choice"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field String */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name === "string"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "string"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Use Essential Support */}

                      {/* -----> Description <----- */}

                      {supportPlan !== "yes" &&
                        noteType?.name === "Progress Note" &&
                        noteType?.custom?.map(
                          (value, index) =>
                            ReturnFormItem(value, index, "text area") && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {ReturnFormItem(value, index, "text area")}
                              </Grid.Col>
                            )
                        )}
                      {noteType?.name !== "Progress Note" &&
                        noteType?.custom?.map(
                          (value, index) =>
                            ReturnFormItem(value, index, "text area") && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {ReturnFormItem(value, index, "text area")}
                              </Grid.Col>
                            )
                        )}
                    </Grid>
                  </Box>

                  {view
                    ? null
                    : supportPlan === "yes"
                    ? null
                    : essentialSupportToggle === "yes"
                    ? null
                    : interventionPlanToggle === "yes"
                    ? null
                    : (isEssentialSupport || !isEssentialSupport) && (
                        <GroupedButtons
                          parentClass={classes.groupedButtonsParent}
                          // funcOne={resetForm}
                          funcOne={() => {
                            resetForm();
                            cancelForm();
                          }}
                          type="submit"
                          cancelBtnClass={classes.cancelNoteBtn}
                          saveBtnClass={classes.saveNoteBtn}
                          textOne={"Cancel"}
                          textTwo={"Save"}
                        />
                      )}

                  {/* support plan map start */}
                  {supportPlan === "yes" &&
                    (noteType?.name === "Progress Note" ||
                      noteType?.custom?.find(
                        (_c) => _c?.field === "Support Plan"
                      )) && (
                      <Box
                        className={[classes.supportPlanAccordion, classes.my]}
                      >
                        {supportPlan === "yes" && (
                          <Box>
                            <Accordion
                              value={openedAccordion}
                              onChange={setOpenedAccordion}
                              chevron={""}
                            >
                              {descriptions?.map((medication, index) => {
                                const labels =
                                  planTypeLabels[medication?.planId];
                                return (
                                  <Accordion.Item
                                    className={[
                                      classes.accordionItem,
                                      classes.addNoteAccordionItem,
                                    ]}
                                    value={`${index}`}
                                  >
                                    <Accordion.Control>
                                      <Flex
                                        align="center"
                                        justify="space-between"
                                        w="100%"
                                        onClick={handleRecordingConfirm}
                                      >
                                        <Text>{`Outcome ${
                                          medication?.details?.outcomeNumber
                                            ? medication?.details?.outcomeNumber
                                            : ""
                                        }`}</Text>
                                        <Flex align="center" gap="8px">
                                          <IconChevronDown
                                            color="gray"
                                            style={{
                                              transition:
                                                "transform 300ms ease-in-out",
                                              transform:
                                                openedAccordion === `${index}`
                                                  ? "rotate(180deg)"
                                                  : "rotate(0deg)",
                                            }}
                                          />
                                          {!view &&
                                            openedAccordion !== `${index}` && (
                                              <Tooltip
                                                label="Delete"
                                                withArrow
                                                position="bottom"
                                              >
                                                <ActionIcon
                                                  color="red"
                                                  variant="transparent"
                                                  onClick={() =>
                                                    removeMedication(
                                                      medication?.id
                                                    )
                                                  }
                                                >
                                                  <RiDeleteBin7Line />
                                                </ActionIcon>
                                              </Tooltip>
                                            )}
                                        </Flex>
                                      </Flex>
                                    </Accordion.Control>
                                    <Accordion.Panel>
                                      <Box
                                        mb={16}
                                        pt={5}
                                        pb={5}
                                        className={classes.deleteBtnParent}
                                      >
                                        <ButtonComp
                                          type=""
                                          text={"Delete"}
                                          icon={
                                            <RiDeleteBin7Line
                                              className={classes.deleteIcon}
                                            />
                                          }
                                          onClick={() =>
                                            removeMedication(medication?.id)
                                          }
                                          btnClass={classes.accordionDeleteBtn}
                                          loading={""}
                                        />
                                      </Box>
                                      <div key={medication?.id}>
                                        {/* view fields */}
                                        {view == true ? (
                                          <Grid
                                            gutter={10}
                                            cols={isMobileScreen ? 1 : 2}
                                            className={classes.mwd}
                                            sx={{
                                              paddingBottom: 30,
                                            }}
                                          >
                                            {/* <Grid.Col
                                              span={isMobileScreen ? 12 : 3}
                                            >
                                              <Box
                                                className={
                                                  classes.outcomeContainer
                                                }
                                              >
                                                <Text
                                                  className={
                                                    classes.outcomeText
                                                  }
                                                >
                                                  {`${
                                                    labels?.addNewButtonLabel ||
                                                    ""
                                                  } Number`}
                                                  <Text c={"red"}>*</Text>
                                                </Text>
                                                <Text
                                                  c={"#909296"}
                                                  ml={10}
                                                  ff={"inter"}
                                                >
                                                  {
                                                    medication?.details
                                                      ?.outcomeNumber
                                                  }
                                                </Text>
                                              </Box>
                                            </Grid.Col> */}
                                            <Grid.Col
                                              span={isMobileScreen ? 12 : 6}
                                            >
                                              <Box
                                                className={
                                                  classes.outcomeContainer
                                                }
                                              >
                                                <Text
                                                  className={
                                                    classes.outcomeText
                                                  }
                                                >
                                                  {`${
                                                    labels?.addNewButtonLabel ||
                                                    ""
                                                  } Title`}
                                                </Text>
                                                <Text
                                                  c={"#909296"}
                                                  ff={"inter"}
                                                  className={
                                                    classes.outcomeTitleView
                                                  }
                                                >
                                                  {" "}
                                                  {
                                                    medication?.details
                                                      ?.outcomeTitle
                                                  }
                                                </Text>
                                              </Box>
                                            </Grid.Col>
                                            <Grid.Col
                                              span={isMobileScreen ? 12 : 6}
                                              mt={6}
                                            >
                                              <Text
                                                className={classes.outcomeText}
                                              >
                                                {`${
                                                  labels?.addNewButtonLabel ||
                                                  ""
                                                } Category`}
                                              </Text>
                                              <Text
                                                c={"#909296"}
                                                ff={"inter"}
                                                className={
                                                  classes.outcomeTitleView
                                                }
                                              >
                                                {" "}
                                                {medication?.outComeCategory}
                                              </Text>
                                              {/* <TextInput
                                                className={classes.input}
                                                label={`${
                                                  labels?.addNewButtonLabel ||
                                                  ""
                                                } Category`}
                                                size="sm"
                                                placeholder="Enter outcome category"
                                                value={
                                                  medication?.outComeCategory
                                                }
                                                disabled
                                              /> */}
                                            </Grid.Col>
                                          </Grid>
                                        ) : (
                                          // Edit fields
                                          <Grid
                                            gutter={10}
                                            cols={isMobileScreen ? 1 : 3}
                                            className={classes.mwd}
                                          >
                                            <Grid.Col xs={12} sm={12} md={6}>
                                              <Select
                                                required
                                                size="sm"
                                                radius={"md"}
                                                className={classes.select}
                                                data={outComeTitle.filter(
                                                  (option) =>
                                                    !descriptions.some(
                                                      (desc) =>
                                                        desc?.id !==
                                                          medication?.id &&
                                                        desc?.outcomeTitle ===
                                                          option?.value
                                                    )
                                                )}
                                                label={
                                                  labels?.outcomeTitleLabel ||
                                                  ""
                                                }
                                                placeholder={`Select ${
                                                  labels?.outcomeTitleLabel ||
                                                  ""
                                                }`}
                                                value={medication?.outcomeTitle}
                                                onChange={(value) => {
                                                  handleMedicationChange(
                                                    medication?.id,
                                                    "outcomeTitle",
                                                    value,
                                                    index
                                                  );
                                                }}
                                                disabled={view}
                                                rightSectionPointerEvents="none"
                                                rightSection={icon}
                                              />
                                              {errors[index] && (
                                                <Text color="red" fz={14}>
                                                  {errors[index]}
                                                </Text>
                                              )}
                                            </Grid.Col>
                                            <Grid.Col xs={12} sm={12} md={6}>
                                              <TextInput
                                                className={classes.input}
                                                radius={"md"}
                                                label={
                                                  labels?.outcomeCategoryLabel ||
                                                  ""
                                                }
                                                size="sm"
                                                placeholder={
                                                  labels?.outcomeCategoryLabel ||
                                                  ""
                                                }
                                                value={
                                                  medication?.outComeCategory
                                                }
                                                disabled
                                              />
                                            </Grid.Col>
                                            {/* -----> Outcome Number <----- */}
                                            <Grid.Col xs={12} sm={12} md={12}>
                                              <Select
                                                id="outcome-number"
                                                size="sm"
                                                radius={"md"}
                                                required
                                                data={outcomeNumbers?.filter(
                                                  (option) =>
                                                    !descriptions?.some(
                                                      (desc) =>
                                                        desc?.id !==
                                                          medication?.id &&
                                                        desc?.outcomeNumber ===
                                                          option.value
                                                    )
                                                )}
                                                label={
                                                  labels?.outcomeNumberLabel ||
                                                  ""
                                                }
                                                // className={classes.selectBG}
                                                placeholder={`Select ${
                                                  labels?.outcomeNumberLabel ||
                                                  ""
                                                }`}
                                                value={
                                                  medication?.outcomeNumber
                                                }
                                                onChange={(value) => {
                                                  handleMedicationChange(
                                                    medication?.id,
                                                    "outcomeNumber",
                                                    value,
                                                    index
                                                  );
                                                }}
                                                disabled={view}
                                                // variant="filled"
                                                rightSectionPointerEvents="none"
                                                rightSection={icon}
                                              />
                                              {errors[index] && (
                                                <Text color="red" fz={14}>
                                                  {errors[index]}
                                                </Text>
                                              )}
                                            </Grid.Col>
                                            {/* <Grid.Col
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                            >
                                              <OutcomeNumber
                                                disabled={true}
                                                num={
                                                  medication?.details
                                                    ?.outcomeNumber
                                                }
                                              />
                                            </Grid.Col> */}
                                          </Grid>
                                        )}
                                        <ViewInfo
                                          data={medication}
                                          labels={labels}
                                        />

                                        {/* -----> Was the goal met? <---- */}
                                        <Select
                                          mt={16}
                                          id="about-goal"
                                          size="sm"
                                          radius={"md"}
                                          className={classes.select}
                                          data={[
                                            "Yes",
                                            "No",
                                            "Goal in progress",
                                            "Not Applicable",
                                          ]}
                                          label="Was this goal met?"
                                          placeholder="Select a response"
                                          value={medication?.metGoal}
                                          onChange={(value) => {
                                            handleMedicationChange(
                                              medication?.id,
                                              "metGoal",
                                              value,
                                              index
                                            );
                                          }}
                                          disabled={view}
                                          rightSectionPointerEvents="none"
                                          rightSection={icon}
                                        />
                                        <Box mt={16}>
                                          <Textarea
                                            id="add-note"
                                            label="Description"
                                            radius={"md"}
                                            className={
                                              classes.essentialDiscriptionArea
                                            }
                                            size="sm"
                                            maxRows={5}
                                            minRows={10}
                                            placeholder="Enter Note"
                                            value={
                                              medication?.description?.length >
                                              0
                                                ? medication?.description
                                                : ""
                                              // : outcomeNotes[index]
                                            }
                                            onChange={(e) => {
                                              handleMedicationChange(
                                                medication?.id,
                                                "description",
                                                e?.target?.value,
                                                index
                                              );

                                              let tempNotesArr = outcomeNotes;
                                              tempNotesArr.splice(
                                                index,
                                                1,
                                                e?.target?.value
                                              );
                                              setOutcomeNotes([
                                                ...tempNotesArr,
                                              ]);
                                            }}
                                            readOnly={view}
                                            autosize={view}
                                          />
                                          {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                descriptions={descriptions}
                                                staffDetials={staffDetials}
                                                messages={medication?.message}
                                                sendMessageToOpenAI={
                                                  sendMessageToOpenAI
                                                }
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                descriptionIndex={index}
                                              />

                                              {!aiAssistantCardOpened &&
                                                isAiAccess && (
                                                  <>
                                                    <Flex
                                                      direction="column"
                                                      px={19}
                                                      bg="#FAFAFA"
                                                      py={8}
                                                      sx={{
                                                        border:
                                                          "1px solid #D0D5DD",
                                                        borderRadius:
                                                          "0px 0px 8px 8px",
                                                      }}
                                                    >
                                                      {/* === Row 1: Credit + Mic + AutoFill === */}
                                                      <Flex
                                                        justify="space-between"
                                                        align="center"
                                                        gap={12}
                                                      >
                                                        <Flex
                                                          align="center"
                                                          gap={8}
                                                        >
                                                          <Text
                                                            ff="inter"
                                                            fw={500}
                                                            fz="md"
                                                          >
                                                            Credit Balance:
                                                          </Text>
                                                          <Text
                                                            ff="inter"
                                                            fw={500}
                                                            fz="md"
                                                          >
                                                            {existingRecord?.planType ===
                                                            "monthly-subscription" || existingRecord?.packageType === "Gold"
                                                              ? "Unlimited"
                                                              : Number(
                                                                  existingRecord?.adminTotalTokens
                                                                )}
                                                          </Text>
                                                        </Flex>

                                                        <Flex
                                                          align="center"
                                                          gap={8}
                                                        >
                                                          {/* Mic button */}
                                                          <UnstyledButton
                                                            disabled={
                                                              view ||
                                                              (existingRecord?.active ===
                                                                false &&
                                                                existingRecord?.paid ===
                                                                  false)
                                                            }
                                                            style={{
                                                              cursor:
                                                                view ||
                                                                (existingRecord?.active ===
                                                                  false &&
                                                                  existingRecord?.paid ===
                                                                    false)
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                            }}
                                                            onClick={() =>
                                                              handleMicStart(
                                                                "description"
                                                              )
                                                            }
                                                          >
                                                            <MicAiSvg
                                                              color={
                                                                view ||
                                                                (existingRecord?.adminTotalTokens ===
                                                                  "" &&
                                                                  existingRecord?.planType ===
                                                                    "onetime-purchase")
                                                                  ? "#A0A0A0"
                                                                  : "#000"
                                                              }
                                                            />
                                                          </UnstyledButton>

                                                          {/* AutoFill button */}
                                                          <UnstyledButton
                                                            disabled={
                                                              view ||
                                                              descriptions?.some(
                                                                (item) =>
                                                                  !item?.description ||
                                                                  item?.description ===
                                                                    ""
                                                              )
                                                            }
                                                            style={{
                                                              cursor:
                                                                view ||
                                                                descriptions?.some(
                                                                  (item) =>
                                                                    !item?.description ||
                                                                    item?.description ===
                                                                      ""
                                                                )
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                            }}
                                                            onClick={() => {
                                                              setShowAiButtons(
                                                                true
                                                              );
                                                            }}
                                                          >
                                                            <AutoFillSvg
                                                              color={
                                                                view ||
                                                                descriptions?.some(
                                                                  (item) =>
                                                                    !item?.description ||
                                                                    item?.description ===
                                                                      ""
                                                                )
                                                                  ? "#A0A0A0"
                                                                  : "#000"
                                                              }
                                                            />
                                                          </UnstyledButton>
                                                        </Flex>
                                                      </Flex>

                                                      {/* === Row 2: Action buttons === */}
                                                      {showAiButtons && (
                                                        <>
                                                          <Divider my="5px" />
                                                          <AiActionButtons
                                                            handleAiAssistantSubmit={
                                                              handleAiAssistantSubmit
                                                            }
                                                            buttonData={
                                                              buttonData
                                                            }
                                                          />
                                                        </>
                                                        //                                                       <Flex
                                                        //                                                         justify="flex-end"
                                                        //                                                         align="center"
                                                        //                                                         mt="xs"
                                                        //                                                         gap="sm"
                                                        //                                                       >
                                                        //                                                         <Button
                                                        //                                                           radius={"md"}
                                                        //                                                           styles={{
                                                        //                                                             root: {
                                                        //                                                               backgroundColor:
                                                        //                                                                 "rgba(120, 86, 255, 0.25)",
                                                        //                                                                 color: "#000",
                                                        //                                                               "&:hover": {
                                                        //                                                                 backgroundColor:
                                                        //                                                                   "rgba(120, 86, 255, 0.50)",
                                                        //                                                               },
                                                        //                                                             },
                                                        //                                                             section: {
                                                        //                                                               marginRight: 6,
                                                        //                                                             },
                                                        //                                                           }}
                                                        //                                                           onClick={() =>
                                                        //                                                             handleAiAssistantSubmit(
                                                        //                                                               "rewriteNotePrompt"
                                                        //                                                             )
                                                        //                                                           }
                                                        //                                                         >
                                                        //                                                           <Flex gap={10} align="center">

                                                        //                                                           <img src="/assets/images/RewriteNoteAiImg.png" alt="Rewrite Note" />
                                                        //                                                           <Text ff={"Inter"} fw={400}>
                                                        //                                                           Rewrite my note
                                                        //                                                           </Text>
                                                        //                                                           </Flex>
                                                        //                                                         </Button>
                                                        //                                                         <Button
                                                        //                                                           onClick={() =>
                                                        //                                                             handleAiAssistantSubmit(
                                                        //                                                               "polishNotePrompt"
                                                        //                                                             )
                                                        //                                                           }
                                                        //                                                           radius={"md"}
                                                        //                                                             styles={{
                                                        //                                                             root: {
                                                        //                                                               backgroundColor:
                                                        //                                                                 "rgba(120, 86, 255, 0.25)",
                                                        //                                                                 color: "#000",
                                                        //                                                               "&:hover": {
                                                        //                                                                 backgroundColor:
                                                        //                                                                   "rgba(120, 86, 255, 0.50)",
                                                        //                                                               },
                                                        //                                                             },
                                                        //                                                             section: {
                                                        //                                                               marginRight: 6,
                                                        //                                                             },
                                                        //                                                           }}
                                                        //                                                         >
                                                        //                                                                 <Flex gap={10} align="center">

                                                        //                                                           <PolishNoteAiSvg/>
                                                        //                                                           <Text ff={"Inter"} fw={400} >
                                                        // Polish my note
                                                        //                                                           </Text>
                                                        //                                                           </Flex>

                                                        //                                                         </Button>
                                                        //                                                       </Flex>
                                                      )}
                                                    </Flex>
                                                  </>
                                                )}
                                            </>
                                          )}
                                        </Box>
                                        <RecordingControls
                                          isListening={isListening}
                                          recordingTime={recordingTime}
                                          onRedo={handleRedo}
                                          onCancel={handleRecordingCancel}
                                          onConfirm={handleRecordingConfirm}
                                          classes={classes}
                                        />
                                        {!view && (
                                          <p
                                            style={{
                                              color: "red",
                                              margin: 0,
                                              padding: 0,
                                            }}
                                          >
                                            {medication?.error}
                                          </p>
                                        )}
                                      </div>
                                    </Accordion.Panel>
                                    <Box
                                      sx={{
                                        border: "1px solid #E4E4E7",
                                        backgroundColor: "#ffffff",
                                      }}
                                    />
                                  </Accordion.Item>
                                );
                              })}
                              {!view && (
                                <GroupedButtons
                                  parentClass={
                                    classes.supportPlanGroupedButtons
                                  }
                                  funcOne={addDescription}
                                  type={"submit"}
                                  cancelBtnClass={classes.cancelNoteBtn}
                                  saveBtnClass={classes.saveNoteBtn}
                                  textOne={"Add New Outcome"}
                                  textTwo={"Save"}
                                  outcomeNumbers={
                                    outcomeNumbers?.length ===
                                    descriptions?.length
                                  }
                                />
                              )}
                            </Accordion>
                          </Box>
                        )}
                      </Box>
                    )}

                  {/* essential plan map start */}
                  {essentialSupportToggle === "yes" && (
                    <Box>
                      <Accordion
                        value={essentialAccordion}
                        onChange={(value) => {
                          if (view === true || edit === true) {
                            let data = essentialSupport?.[value];
                            handleEssentialTypeChangeForNoteView(
                              data?.essentialSupportType,
                              data?.howOftenEssentialSupport
                            );
                          }
                          setEssentialAccordion(value);
                        }}
                        mt={16}
                        variant="separated"
                        chevron={<IconChevronDown size={34} color="#000000" />}
                        chevronPosition="right"
                        chevronSize={20}
                        className={classes.essentialAccordion}
                        styles={{
                          chevron: {
                            transition: "transform 200ms ease",
                            "&[data-active]": {
                              transform: "rotate(180deg)",
                            },
                          },
                        }}
                      >
                        {Array.isArray(essentialSupport) &&
                          essentialSupport?.map((support, index) => (
                            <Accordion.Item
                              key={support?.id}
                              value={String(index)}
                              className={classes.essentialAccordionItem}
                            >
                              <Accordion.Control>
                                <Box
                                  className={classes.accordionControl}
                                  onClick={handleRecordingConfirm}
                                >
                                  <Text
                                    color="#262626"
                                    fz={16}
                                    fw={500}
                                    ff="Inter"
                                  >
                                    Essential Support {""}
                                    {support?.essentialNumber
                                      ? support.essentialNumber
                                      : ""}
                                    {/* {index + 1} */}
                                  </Text>
                                </Box>
                              </Accordion.Control>

                              <Accordion.Panel>
                                <Grid
                                  gutter={0}
                                  sx={{
                                    paddingBottom: 26,
                                  }}
                                  className={classes.mwd}
                                >
                                  {!view && (
                                    <Grid.Col span={12}>
                                      <Box
                                        mb={26}
                                        className={classes.outcomeDeleteBTN}
                                      >
                                        <Text
                                          onClick={() =>
                                            removeEssentialSupport(support?.id)
                                          }
                                        >
                                          <AiOutlineDelete size={20} />
                                          Delete
                                        </Text>
                                      </Box>
                                    </Grid.Col>
                                  )}
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      data={essentialSupportTypeState}
                                      // data={
                                      //   selectedSupportType
                                      //     ? essentialSupportTypeState.filter(
                                      //         (item) =>
                                      //           item.value ===
                                      //             support?.essentialSupportType ||
                                      //           item.value !==
                                      //             selectedSupportType
                                      //       )
                                      //     : essentialSupportTypeState
                                      // }
                                      label={"Essential Support Type"}
                                      className={classes.select}
                                      placeholder={"Select Type"}
                                      readOnly={view}
                                      value={
                                        support?.essentialSupportType || ""
                                      }
                                      // disabled={true}
                                      onChange={(value) => {
                                        handleEssentialTypeChange(
                                          support?.id,
                                          "essentialSupportType",
                                          value,
                                          index
                                        );
                                      }}
                                      // error={
                                      //   essentialSupportErrors[index] &&
                                      //   !support?.essentialSupportType &&
                                      //   "Support Type is required"
                                      // }
                                      variant="filled"
                                      // mx={{ base: 0, sm: 17 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <Select
                                      id="essential-support-frequency"
                                      size="sm"
                                      required
                                      data={frequencyOptions || []}
                                      label={"Frequency"}
                                      className={classes.select}
                                      placeholder={"Select Frequency"}
                                      value={
                                        support?.howOftenEssentialSupport || ""
                                      } // ✅ set value
                                      onChange={(value) => {
                                        // setSelectedFrequency(value); // ✅ store user's selection
                                        handleEssentialFrequencyChange(
                                          support?.id,
                                          "howOftenEssentialSupport",
                                          value,
                                          index
                                        );
                                      }}
                                      readOnly={view}
                                      variant="filled"
                                      mx={{ base: 0, sm: 10 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                  >
                                    <Select
                                      id="essential-support-outcome-number"
                                      size="sm"
                                      required
                                      data={essentialNumber || []}
                                      label={"Outcome #"}
                                      className={classes.select}
                                      placeholder={"#"}
                                      readOnly={view}
                                      value={support?.essentialNumber || ""} // ✅ set value
                                      onChange={(value) => {
                                        handleEssentialNumberChange(
                                          support?.id,
                                          "essentialNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      variant="filled"
                                      // mx={{ base: 0, sm: 10 }}
                                      // my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                    {/* <TextInput
                                      id="essential-support-type"
                                      size="sm"
                                      disabled
                                      label={"Outcome #"}
                                      value={
                                        essentialNumber
                                      }
                                      className={classes.input}
                                      placeholder={"#"}
                                      variant="filled"
                                      withAsterisk={false}
                                    /> */}
                                  </Grid.Col>
                                </Grid>
                                <Grid mb={10}>
                                  <Grid.Col>
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      // data={essentialSupportNumber}
                                      // data={activities?.map((activity) => ({
                                      //   label: activity.supportStatement, // Use the support statement as the label
                                      //   value: activity.id, // Use the activity number as the value
                                      // }))}
                                      data={activities
                                        ?.filter(
                                          (activity) =>
                                            // Only show activities not selected in other supports (except this one)
                                            !essentialSupport.some(
                                              (s, i) =>
                                                i !== index &&
                                                s?.essentialActivityNumber ===
                                                  activity.id
                                            )
                                        )
                                        .map((activity) => ({
                                          label: activity?.supportStatement,
                                          value: activity?.id,
                                        }))}
                                      label={"Essential Support Activities"}
                                      className={classes.select}
                                      placeholder={"Select Activities"}
                                      value={
                                        support?.essentialActivityNumber || ""
                                      }
                                      onChange={(value) => {
                                        handleEssentialChange(
                                          support?.id,
                                          "essentialActivityNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      disabled={view}
                                      error={
                                        essentialSupportErrors[index] &&
                                        !support?.essentialActivityNumber &&
                                        "Support Activity is required"
                                      }
                                      withAsterisk={false}
                                      variant="filled"
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                      nothingFound={"Activities already added"}
                                    />
                                  </Grid.Col>
                                </Grid>
                                <EssentialViewInfo
                                  data={support}
                                  className={classes.essentialViewInfoAccordion}
                                />
                                <Textarea
                                  id="add-note"
                                  className={classes.essentialDiscriptionArea}
                                  size="sm"
                                  label="Description"
                                  maxRows={5}
                                  minRows={10}
                                  placeholder="Enter Note"
                                  value={
                                    support?.description?.length > 0
                                      ? support?.description
                                      : ""
                                    // : essentialNotes[index]
                                  }
                                  onChange={(e) => {
                                    handleEssentialSupportDesc(
                                      support?.id,
                                      "description",
                                      e?.target?.value,
                                      index
                                    );
                                    let tempNotesArr = essentialNotes;
                                    tempNotesArr.splice(
                                      index,
                                      1,
                                      e?.target?.value
                                    );
                                    setEssentialNotes([...tempNotesArr]);
                                  }}
                                  // disabled={view}
                                  readOnly={view}
                                  autosize={view}
                                />
                                {!view && (
                                  <>
                                    <AiAssistantChatCard
                                      open={aiAssistantCardOpened}
                                      handleAiAssistantSubmit={
                                        handleAiAssistantSubmit
                                      }
                                      form={form}
                                      // descriptions={descriptions}
                                      support={support}
                                      messages={support?.message}
                                      sendMessageToOpenAI={sendMessageToOpenAI}
                                      loading={loading}
                                      messageValue={messageValue}
                                      formErrors={formErrors}
                                      setAiAssistantCardOpened={
                                        setAiAssistantCardOpened
                                      }
                                      essentialSupportIndex={index}
                                    />
                                    {!aiAssistantCardOpened && isAiAccess && (
                                      <>
                                        <Flex
                                          direction="column"
                                          px={19}
                                          bg="#FAFAFA"
                                          py={8}
                                          sx={{
                                            border: "1px solid #D0D5DD",
                                            borderRadius: "0px 0px 8px 8px",
                                          }}
                                        >
                                          <Flex
                                            justify="space-between"
                                            align="center"
                                            gap={12}
                                          >
                                            <Flex align={"center"} gap={8}>
                                              <Text
                                                ff={"inter"}
                                                fw={500}
                                                fz={"md"}
                                              >
                                                Credit Balance:{" "}
                                              </Text>
                                              <Text
                                                ff={"inter"}
                                                fw={500}
                                                fz={"md"}
                                              >
                                                {/* {existingRecord?.active && existingRecord?.paid */}
                                                {existingRecord?.planType ===
                                                "monthly-subscription" || existingRecord?.packageType === "Gold"
                                                  ? "Unlimited"
                                                  : Number(
                                                      existingRecord?.adminTotalTokens
                                                    )}
                                              </Text>
                                            </Flex>
                                            <Flex align={"center"} gap={8}>
                                              <UnstyledButton
                                                disabled={
                                                  view ||
                                                  (existingRecord?.active ===
                                                    false &&
                                                    existingRecord?.paid ===
                                                      false)
                                                }
                                                style={{
                                                  cursor:
                                                    view ||
                                                    (existingRecord?.active ===
                                                      false &&
                                                      existingRecord?.paid ===
                                                        false)
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() => {
                                                  handleMicStart("essential");
                                                }}
                                              >
                                                <MicAiSvg
                                                  color={
                                                    view ||
                                                    (existingRecord?.adminTotalTokens ===
                                                      "" &&
                                                      existingRecord?.planType ===
                                                        "onetime-purchase")
                                                      ? "#A0A0A0"
                                                      : "#000"
                                                  }
                                                />
                                              </UnstyledButton>
                                              <UnstyledButton
                                                disabled={
                                                  view ||
                                                  !support?.description ||
                                                  support?.description === ""
                                                }
                                                style={{
                                                  cursor:
                                                    view ||
                                                    !support?.description ||
                                                    support?.description === ""
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                                onClick={() => {
                                                  setShowAiButtons(true);
                                                }}
                                              >
                                                <AutoFillSvg
                                                  color={
                                                    view ||
                                                    !support?.description ||
                                                    support?.description === ""
                                                      ? "#A0A0A0"
                                                      : "#000"
                                                  }
                                                />
                                              </UnstyledButton>
                                            </Flex>
                                          </Flex>

                                          {showAiButtons && (
                                            <>
                                              <Divider my="5px" />
                                              <AiActionButtons
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                buttonData={buttonData}
                                              />
                                            </>
                                            // <Flex
                                            //   justify="flex-end"
                                            //   align="center"
                                            //   mt="xs"
                                            //   gap="sm"
                                            // >
                                            //   <Button
                                            //     variant="outline"
                                            //     onClick={() =>
                                            //       handleAiAssistantSubmit(
                                            //         "rewriteNotePrompt"
                                            //       )
                                            //     }
                                            //   >
                                            //     Rewrite my note
                                            //   </Button>
                                            //   <Button
                                            //     onClick={() =>
                                            //       handleAiAssistantSubmit(
                                            //         "polishNotePrompt"
                                            //       )
                                            //     }
                                            //   >
                                            //     Polish my note
                                            //   </Button>
                                            // </Flex>
                                          )}
                                        </Flex>
                                      </>
                                    )}
                                  </>
                                )}
                                <RecordingControls
                                  isListening={isListening}
                                  recordingTime={recordingTime}
                                  onRedo={handleRedo}
                                  onCancel={handleRecordingCancel}
                                  onConfirm={handleRecordingConfirm}
                                  classes={classes}
                                />
                              </Accordion.Panel>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                    </Box>
                  )}

                  {!view && essentialSupportToggle === "yes" && (
                    <>
                      <GroupedButtons
                        parentClass={classes.groupedButtonsParent}
                        funcOne={addEssentialSupport}
                        type={"submit"}
                        cancelBtnClass={classes.cancelNoteBtn}
                        saveBtnClass={classes.saveNoteBtn}
                        textOne={"Add Essential Support"}
                        textTwo={"Save"}
                      />
                    </>
                  )}

                  {/* intervention plan map start */}
                  {interventionPlanToggle === "yes" && (
                    <Box>
                      <Accordion
                        value={goalsAccordion}
                        onChange={(value) => {
                          // if (view === true || edit === true) {
                          //   let data = essentialSupport?.[value];
                          //   handleEssentialTypeChangeForNoteView(
                          //     data?.essentialSupportType,
                          //     data?.howOftenEssentialSupport
                          //   );
                          // }
                          setGoalsAccordion(value);
                        }}
                        mt={16}
                        variant="separated"
                        chevron={<IconChevronDown size={34} color="#000000" />}
                        chevronPosition="right"
                        chevronSize={20}
                        className={classes.essentialAccordion}
                        styles={{
                          chevron: {
                            transition: "transform 200ms ease",
                            "&[data-active]": {
                              transform: "rotate(180deg)",
                            },
                          },
                        }}
                      >
                        {Array.isArray(goals) &&
                          goals?.map((goalItem, index) => (
                            <Accordion.Item
                              key={goalItem?.id}
                              value={String(index)}
                              className={classes.essentialAccordionItem}
                            >
                              <Accordion.Control>
                                <Box
                                  className={classes.accordionControl}
                                  onClick={handleRecordingConfirm}
                                >
                                  <Text
                                    color="#262626"
                                    fz={16}
                                    fw={500}
                                    ff="Inter"
                                  >
                                    Goal {""}
                                    {goalItem?.goalNumber
                                      ? goalItem.goalNumber
                                      : index + 1}
                                    {/* {index + 1} */}
                                  </Text>
                                </Box>
                              </Accordion.Control>

                              <Accordion.Panel>
                                <Grid
                                  gutter={26}
                                  sx={{
                                    paddingBottom: 26,
                                  }}
                                  className={classes.mwd}
                                >
                                  {!view && (
                                    <Grid.Col span={12}>
                                      <Box
                                        mb={26}
                                        className={classes.outcomeDeleteBTN}
                                      >
                                        <Text
                                          onClick={() =>
                                            removeGoal(goalItem?.id)
                                          }
                                        >
                                          <AiOutlineDelete size={20} />
                                          Delete
                                        </Text>
                                      </Box>
                                    </Grid.Col>
                                  )}
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <TimeInput
                                      label="Start Time"
                                      className={classes.datePicker}
                                      icon={
                                        <img
                                          style={{ width: "20px" }}
                                          src={"/assets/images/clock.png"}
                                          alt="Icon"
                                        />
                                      }
                                      format="12"
                                      value={goalItem?.startTimeGoal || ""}
                                      onChange={(e) => {
                                        const isSafari =
                                          /^((?!chrome|android).)*safari/i.test(
                                            navigator.userAgent
                                          );
                                        let time = e.target.value
                                          .split(":")
                                          ?.slice(0, 2)
                                          ?.join(":");
                                        isSafari
                                          ? handleEssentialSupportDesc(
                                              goalItem.id,
                                              "startTimeGoal",
                                              time,
                                              index
                                            )
                                          : handleEssentialSupportDesc(
                                              goalItem.id,
                                              "startTimeGoal",
                                              time,
                                              index
                                            );
                                      }}
                                      disabled={view}
                                    />
                                  </Grid.Col>
                                  <Grid.Col span={2}>
                                    <Flex
                                      align="center"
                                      justify="center"
                                      h="100%"
                                      pt={28}
                                    >
                                      <Text fz={25} color="#000" fw={400}>
                                        -
                                      </Text>
                                    </Flex>
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <TimeInput
                                      label="End Time"
                                      format="12"
                                      className={classes.datePicker}
                                      icon={
                                        <img
                                          style={{ width: "20px" }}
                                          src={"/assets/images/clock.png"}
                                          alt="Icon"
                                        />
                                      }
                                      value={goalItem?.endTimeGoal || ""}
                                      onChange={(e) => {
                                        const isSafari =
                                          /^((?!chrome|android).)*safari/i.test(
                                            navigator.userAgent
                                          );
                                        let time = e.target.value
                                          .split(":")
                                          ?.slice(0, 2)
                                          ?.join(":");
                                        isSafari
                                          ? handleEssentialSupportDesc(
                                              goalItem.id,
                                              "endTimeGoal",
                                              time,
                                              index
                                            )
                                          : handleEssentialSupportDesc(
                                              goalItem.id,
                                              "endTimeGoal",
                                              time,
                                              index
                                            );
                                      }}
                                      disabled={view}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={10}
                                    lg={10}
                                    xl={10}
                                  >
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      data={goalOptions.filter(
                                        (g) =>
                                          !goals.some(
                                            (gi) =>
                                              gi.identifiedGoal === g.value &&
                                              gi.id !== goalItem.id
                                          )
                                      )}
                                      label={"Identified Goals"}
                                      className={classes.select}
                                      placeholder={"Select Identified Goals"}
                                      readOnly={view}
                                      value={goalItem?.identifiedGoal || ""}
                                      // disabled={true}
                                      onChange={(value) => {
                                        handleEssentialTypeChange(
                                          goalItem?.id,
                                          "identifiedGoal",
                                          value,
                                          index
                                        );
                                      }}
                                      // error={
                                      //   essentialSupportErrors[index] &&
                                      //   !goalItem?.identifiedGoal &&
                                      //   "Support Type is required"
                                      // }
                                      variant="filled"
                                      // mx={{ base: 0, sm: 17 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                  >
                                    <Select
                                      id="essential-goalItem-outcome-number"
                                      size="sm"
                                      required
                                      data={goalNumber || []}
                                      label={"Goal #"}
                                      className={classes.select}
                                      placeholder={"#"}
                                      readOnly={view}
                                      value={goalItem?.goalNumber || ""} // ✅ set value
                                      onChange={(value) => {
                                        handleEssentialNumberChange(
                                          goalItem?.id,
                                          "goalNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      variant="filled"
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                </Grid>

                                {goalItems[index]?.map((_gi, gIndex) => (
                                  <Grid key={_gi.id} mb={10}>
                                    <Grid.Col
                                      xs={12}
                                      sm={12}
                                      md={!view ? 11 : 12}
                                      lg={!view ? 11 : 12}
                                      xl={!view ? 11 : 12}
                                    >
                                      <Box
                                        className={classes.interventionGoalItem}
                                      >
                                        {view ? (
                                          <Box className={classes.goalItemsBox}>
                                            <Text
                                              size="sm"
                                              fw={500}
                                              ff={"Inter"}
                                            >
                                              Objective
                                            </Text>
                                            <Text size="sm" ff={"Inter"}>
                                              {_gi?.objectives || ""}
                                            </Text>
                                          </Box>
                                        ) : (
                                          <Select
                                            id={`essential-goalItem-type-${_gi.id}`}
                                            size="sm"
                                            required
                                            data={objectivesByGoal?.filter(
                                              (o) =>
                                                !goalItems[index].some(
                                                  (g) =>
                                                    g?.objectives ===
                                                      o?.value &&
                                                    g.id !== _gi.id
                                                )
                                            )}
                                            // data={objectivesByGoal}
                                            label="Objective"
                                            className={classes.select}
                                            placeholder="Select Objective"
                                            readOnly={view}
                                            value={_gi?.objectives || ""}
                                            onChange={(value) =>
                                              handleGoalActivityChange(
                                                _gi.id,
                                                "objectives",
                                                value,
                                                gIndex,
                                                index
                                              )
                                            }
                                            mb={10}
                                            withAsterisk={false}
                                            rightSectionPointerEvents="none"
                                            rightSection={icon}
                                          />
                                        )}

                                        {view ? (
                                          <Box className={classes.goalItemsBox}>
                                            <Text
                                              size="sm"
                                              fw={500}
                                              ff={"Inter"}
                                            >
                                              Intervention Instruction
                                            </Text>
                                            <Text size="sm" ff={"Inter"}>
                                              {_gi?.Intervention_Instruction ||
                                                ""}
                                            </Text>
                                          </Box>
                                        ) : (
                                          <Select
                                            id={`essential-goalItem-frequency-${goalItem.id}`}
                                            size="sm"
                                            required
                                            data={interventionsByGoal.filter(
                                              (i) =>
                                                !goalItems[index].some(
                                                  (g) =>
                                                    g.Intervention_Instruction ===
                                                      i.value && g.id !== _gi.id
                                                )
                                            )}
                                            // data={interventionsByGoal}
                                            label="Intervention"
                                            className={classes.select}
                                            placeholder="Select Intervention"
                                            value={
                                              _gi?.Intervention_Instruction ||
                                              ""
                                            }
                                            onChange={(value) =>
                                              handleGoalActivityChange(
                                                _gi.id,
                                                "Intervention_Instruction",
                                                value,
                                                gIndex,
                                                index
                                              )
                                            }
                                            readOnly={view}
                                            withAsterisk={false}
                                            rightSectionPointerEvents="none"
                                            rightSection={icon}
                                          />
                                        )}
                                      </Box>
                                    </Grid.Col>

                                    {!view && (
                                      <Grid.Col xs={12} sm={12} md={1} gap={10}>
                                        <Flex
                                          direction="column"
                                          gap={10}
                                          justify="center"
                                          align="center"
                                          h="100%"
                                        >
                                          <Button
                                            onClick={() =>
                                              handleAddGoalItem(index)
                                            }
                                            className={
                                              classes.interventionAddGoalItem
                                            }
                                            disabled={view || isAddDisabled}
                                            sx={{
                                              opacity:
                                                view || isAddDisabled ? 0.5 : 1,
                                              pointerEvents:
                                                view || isAddDisabled
                                                  ? "none"
                                                  : "auto",
                                              cursor:
                                                view || isAddDisabled
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                          >
                                            <TbPlus
                                              size={15}
                                              color="rgba(0, 0, 0, 1)"
                                            />
                                          </Button>
                                          <Button
                                            onClick={() =>
                                              handleRemoveGoalItem(
                                                _gi.id,
                                                index
                                              )
                                            }
                                            className={
                                              classes.interventionAddGoalItem
                                            }
                                            disabled={
                                              goalItems[index]?.length === 1
                                            } // keep at least 1 row
                                            sx={{
                                              opacity:
                                                goalItems[index]?.length === 1
                                                  ? 0.5
                                                  : 1,
                                              pointerEvents:
                                                goalItems[index]?.length === 1
                                                  ? "none"
                                                  : "auto",
                                              cursor:
                                                goalItems[index]?.length === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                          >
                                            <TbTrash
                                              size={15}
                                              color="rgba(0, 0, 0, 1)"
                                            />
                                          </Button>
                                        </Flex>
                                      </Grid.Col>
                                    )}
                                  </Grid>
                                ))}

                                {/* Behavior Description */}
                                <Textarea
                                  id="add-note"
                                  className={classes.essentialDiscriptionArea}
                                  size="sm"
                                  label="Behavior"
                                  maxRows={5}
                                  minRows={10}
                                  placeholder="Enter behavior"
                                  value={
                                    goalItem?.behaviorDescription?.length > 0
                                      ? goalItem?.behaviorDescription
                                      : ""
                                    // : essentialNotes[index]
                                  }
                                  onChange={(e) => {
                                    handleEssentialSupportDesc(
                                      goalItem?.id,
                                      "behaviorDescription",
                                      e?.target?.value,
                                      index
                                    );
                                    let tempNotesArr = essentialNotes;
                                    tempNotesArr.splice(
                                      index,
                                      1,
                                      e?.target?.value
                                    );
                                    setEssentialNotes([...tempNotesArr]);
                                  }}
                                  // disabled={view}
                                  readOnly={view}
                                  autosize={view}
                                />
                                {!view && (
                                  <>
                                    <AiAssistantChatCard
                                      open={behaviorCardOpened}
                                      handleAiAssistantSubmit={() =>
                                        handleAiAssistantSubmit("behavior")
                                      }
                                      form={form}
                                      goals={goalItem}
                                      messages={goalItem?.behaviorAiReply}
                                      sendMessageToOpenAI={sendMessageToOpenAI}
                                      loading={behaviorLoading}
                                      messageValue={messageValue}
                                      formErrors={formErrors}
                                      setAiAssistantCardOpened={
                                        setBehaviorCardOpened
                                      }
                                      essentialSupportIndex={index}
                                      type={"behavior"}
                                      interventionPlanToggle={
                                        interventionPlanToggle
                                      }
                                    />
                                    {!behaviorCardOpened && isAiAccess && (
                                      <Flex
                                        px={19}
                                        bg={"#FAFAFA"}
                                        py={8}
                                        justify="space-between"
                                        align={"center"}
                                        gap={12}
                                        sx={{
                                          border: "1px solid #D0D5DD",
                                          borderRadius: "0px 0px 8px 8px",
                                        }}
                                      >
                                        <Flex align={"center"} gap={8}>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            Credit Balance:{" "}
                                          </Text>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            {existingRecord?.planType ===
                                            "monthly-subscription" || existingRecord?.packageType === "Gold"
                                              ? "Unlimited"
                                              : Number(
                                                  existingRecord?.adminTotalTokens
                                                )}
                                          </Text>
                                        </Flex>
                                        <Flex align={"center"} gap={8}>
                                          <UnstyledButton
                                            // disabled={
                                            //   view || responseIsListening || planIsListening &&
                                            //   (existingRecord.active ===
                                            //     false &&
                                            //     existingRecord.paid === false)
                                            // }
                                            disabled={
                                              view ||
                                              micLabel === "plan" ||
                                              micLabel === "response" ||
                                              (existingRecord?.active ===
                                                false &&
                                                existingRecord?.paid === false)
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                micLabel === "plan" ||
                                                micLabel === "response" ||
                                                (existingRecord?.active ===
                                                  false &&
                                                  existingRecord?.paid ===
                                                    false)
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() => {
                                              handleMicStart("behavior");
                                            }}
                                          >
                                            <MicAiSvg
                                              color={
                                                view ||
                                                micLabel === "plan" ||
                                                micLabel === "response" ||
                                                (existingRecord?.adminTotalTokens ===
                                                  "" &&
                                                  existingRecord?.planType ===
                                                    "onetime-purchase")
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                          <UnstyledButton
                                            disabled={
                                              view ||
                                              !goalItem?.behaviorDescription ||
                                              goalItem?.behaviorDescription ===
                                                ""
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                !goalItem?.behaviorDescription ||
                                                goalItem?.behaviorDescription ===
                                                  ""
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() =>
                                              handleAiAssistantSubmit(
                                                "behavior"
                                              )
                                            }
                                          >
                                            <AutoFillSvg
                                              color={
                                                view ||
                                                !goalItem?.behaviorDescription ||
                                                goalItem?.behaviorDescription ===
                                                  ""
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                        </Flex>
                                      </Flex>
                                    )}
                                  </>
                                )}
                                <RecordingControls
                                  // isListening={behaviorIsListening}
                                  isListening={
                                    micLabel === "behavior" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("behavior")}
                                  onCancel={() =>
                                    handleRecordingCancel("behavior")
                                  }
                                  onConfirm={() =>
                                    handleRecordingConfirm("behavior")
                                  }
                                  classes={classes}
                                />
                                {/* Response Description */}

                                <Textarea
                                  id="add-note"
                                  className={classes.essentialDiscriptionArea}
                                  size="sm"
                                  label="Response"
                                  maxRows={5}
                                  minRows={10}
                                  mt={10}
                                  placeholder="Enter Response"
                                  value={
                                    goalItem?.responseDescription?.length > 0
                                      ? goalItem?.responseDescription
                                      : ""
                                    // : essentialNotes[index]
                                  }
                                  onChange={(e) => {
                                    handleEssentialSupportDesc(
                                      goalItem?.id,
                                      "responseDescription",
                                      e?.target?.value,
                                      index
                                    );
                                    // let tempNotesArr = essentialNotes;
                                    // tempNotesArr.splice(
                                    //   index,
                                    //   1,
                                    //   e?.target?.value
                                    // );
                                    // setEssentialNotes([...tempNotesArr]);
                                  }}
                                  // disabled={view}
                                  readOnly={view}
                                  autosize={view}
                                />
                                {!view && (
                                  <>
                                    <AiAssistantChatCard
                                      open={responseCardOpened}
                                      handleAiAssistantSubmit={() =>
                                        handleAiAssistantSubmit("response")
                                      }
                                      form={form}
                                      goals={goalItem}
                                      messages={goalItem?.responseAiReply}
                                      sendMessageToOpenAI={sendMessageToOpenAI}
                                      loading={responseLoading}
                                      messageValue={messageValue}
                                      formErrors={formErrors}
                                      setAiAssistantCardOpened={
                                        setResponseCardOpened
                                      }
                                      essentialSupportIndex={index}
                                      type={"response"}
                                      interventionPlanToggle={
                                        interventionPlanToggle
                                      }
                                    />
                                    {!responseCardOpened && isAiAccess && (
                                      <Flex
                                        px={19}
                                        bg={"#FAFAFA"}
                                        py={8}
                                        justify="space-between"
                                        align={"center"}
                                        gap={12}
                                        sx={{
                                          border: "1px solid #D0D5DD",
                                          borderRadius: "0px 0px 8px 8px",
                                        }}
                                      >
                                        <Flex align={"center"} gap={8}>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            Credit Balance:{" "}
                                          </Text>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            {existingRecord?.planType ===
                                            "monthly-subscription" || existingRecord?.packageType === "Gold"
                                              ? "Unlimited"
                                              : Number(
                                                  existingRecord?.adminTotalTokens
                                                )}
                                          </Text>
                                        </Flex>
                                        <Flex align={"center"} gap={8}>
                                          <UnstyledButton
                                            // disabled={
                                            //   view || behaviorIsListening || planIsListening &&
                                            //   (existingRecord.active ===
                                            //     false &&
                                            //     existingRecord.paid === false)
                                            // }
                                            disabled={
                                              view ||
                                              micLabel === "behavior" ||
                                              micLabel === "plan" ||
                                              (existingRecord?.active ===
                                                false &&
                                                existingRecord?.paid === false)
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                micLabel === "behavior" ||
                                                micLabel === "plan" ||
                                                (existingRecord?.active ===
                                                  false &&
                                                  existingRecord?.paid ===
                                                    false)
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() => {
                                              handleMicStart("response");
                                            }}
                                          >
                                            <MicAiSvg
                                              color={
                                                view ||
                                                micLabel === "behavior" ||
                                                micLabel === "plan" ||
                                                (existingRecord?.adminTotalTokens ===
                                                  "" &&
                                                  existingRecord?.planType ===
                                                    "onetime-purchase")
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                          <UnstyledButton
                                            disabled={
                                              view ||
                                              !goalItem?.responseDescription ||
                                              goalItem?.responseDescription ===
                                                ""
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                !goalItem?.responseDescription ||
                                                goalItem?.responseDescription ===
                                                  ""
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() =>
                                              handleAiAssistantSubmit(
                                                "response"
                                              )
                                            }
                                          >
                                            <AutoFillSvg
                                              color={
                                                view ||
                                                !goalItem?.responseDescription ||
                                                goalItem?.responseDescription ===
                                                  ""
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                        </Flex>
                                      </Flex>
                                    )}
                                  </>
                                )}
                                <RecordingControls
                                  // isListening={responseIsListening}
                                  isListening={
                                    micLabel === "response" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("response")}
                                  onCancel={() =>
                                    handleRecordingCancel("response")
                                  }
                                  onConfirm={() =>
                                    handleRecordingConfirm("response")
                                  }
                                  classes={classes}
                                />

                                {/* Plan description */}
                                <Textarea
                                  id="add-note"
                                  className={classes.essentialDiscriptionArea}
                                  size="sm"
                                  label="Plan"
                                  mt={10}
                                  maxRows={5}
                                  minRows={10}
                                  placeholder="Enter Plan"
                                  value={
                                    goalItem?.planDescription?.length > 0
                                      ? goalItem?.planDescription
                                      : ""
                                    // : essentialNotes[index]
                                  }
                                  onChange={(e) => {
                                    handleEssentialSupportDesc(
                                      goalItem?.id,
                                      "planDescription",
                                      e?.target?.value,
                                      index
                                    );
                                    // let tempNotesArr = essentialNotes;
                                    // tempNotesArr.splice(
                                    //   index,
                                    //   1,
                                    //   e?.target?.value
                                    // );
                                    // setEssentialNotes([...tempNotesArr]);
                                  }}
                                  // disabled={view}
                                  readOnly={view}
                                  autosize={view}
                                />
                                {!view && (
                                  <>
                                    <AiAssistantChatCard
                                      open={planCardOpened}
                                      handleAiAssistantSubmit={() =>
                                        handleAiAssistantSubmit("plan")
                                      }
                                      form={form}
                                      goals={goalItem}
                                      messages={goalItem?.planAiReply}
                                      sendMessageToOpenAI={sendMessageToOpenAI}
                                      loading={planLoading}
                                      messageValue={messageValue}
                                      formErrors={formErrors}
                                      setAiAssistantCardOpened={
                                        setPlanCardOpened
                                      }
                                      essentialSupportIndex={index}
                                      type={"plan"}
                                      interventionPlanToggle={
                                        interventionPlanToggle
                                      }
                                    />
                                    {!planCardOpened && isAiAccess && (
                                      <Flex
                                        px={19}
                                        bg={"#FAFAFA"}
                                        py={8}
                                        justify="space-between"
                                        align={"center"}
                                        gap={12}
                                        sx={{
                                          border: "1px solid #D0D5DD",
                                          borderRadius: "0px 0px 8px 8px",
                                        }}
                                      >
                                        <Flex align={"center"} gap={8}>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            Credit Balance:{" "}
                                          </Text>
                                          <Text ff={"inter"} fw={500} fz={"md"}>
                                            {existingRecord?.planType ===
                                            "monthly-subscription" || existingRecord?.packageType === "Gold"
                                              ? "Unlimited"
                                              : Number(
                                                  existingRecord?.adminTotalTokens
                                                )}
                                          </Text>
                                        </Flex>
                                        <Flex align={"center"} gap={8}>
                                          <UnstyledButton
                                            // disabled={
                                            //   view || behaviorIsListening || responseIsListening
                                            //   (existingRecord.active ===
                                            //     false &&
                                            //     existingRecord.paid === false)
                                            // }
                                            disabled={
                                              view ||
                                              micLabel === "behavior" ||
                                              micLabel === "response" ||
                                              (existingRecord?.active ===
                                                false &&
                                                existingRecord?.paid === false)
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                micLabel === "behavior" ||
                                                micLabel === "response" ||
                                                (existingRecord?.active ===
                                                  false &&
                                                  existingRecord?.paid ===
                                                    false)
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() => {
                                              handleMicStart("plan");
                                            }}
                                          >
                                            <MicAiSvg
                                              color={
                                                view ||
                                                micLabel === "behavior" ||
                                                micLabel === "response" ||
                                                (existingRecord?.adminTotalTokens ===
                                                  "" &&
                                                  existingRecord?.planType ===
                                                    "onetime-purchase")
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                          <UnstyledButton
                                            disabled={
                                              view ||
                                              !goalItem?.planDescription ||
                                              goalItem?.planDescription === ""
                                            }
                                            style={{
                                              cursor:
                                                view ||
                                                !goalItem?.planDescription ||
                                                goalItem?.planDescription === ""
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            onClick={() =>
                                              handleAiAssistantSubmit("plan")
                                            }
                                          >
                                            <AutoFillSvg
                                              color={
                                                view ||
                                                !goalItem?.planDescription ||
                                                goalItem?.planDescription === ""
                                                  ? "#A0A0A0"
                                                  : "#000"
                                              }
                                            />
                                          </UnstyledButton>
                                        </Flex>
                                      </Flex>
                                    )}
                                  </>
                                )}
                                <RecordingControls
                                  // isListening={planIsListening}
                                  isListening={
                                    micLabel === "plan" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("plan")}
                                  onCancel={() => handleRecordingCancel("plan")}
                                  onConfirm={() =>
                                    handleRecordingConfirm("plan")
                                  }
                                  classes={classes}
                                />
                                <Select
                                  mt={16}
                                  id="about-goal"
                                  size="sm"
                                  radius={"md"}
                                  className={classes.select}
                                  data={[
                                    "Yes",
                                    "No",
                                    "Goal in progress",
                                    "Not Applicable",
                                  ]}
                                  label="Was this goal met?"
                                  placeholder="Select a response"
                                  value={goalItem?.metGoalIntervention}
                                  onChange={(value) => {
                                    handleEssentialSupportDesc(
                                      goalItem?.id,
                                      "metGoalIntervention",
                                      value,
                                      index
                                    );
                                  }}
                                  disabled={view}
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                              </Accordion.Panel>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                    </Box>
                  )}

                  {!view && interventionPlanToggle === "yes" && (
                    <>
                      <GroupedButtons
                        parentClass={classes.groupedButtonsParent}
                        funcOne={addNewGoal}
                        type={"submit"}
                        cancelBtnClass={classes.cancelNoteBtn}
                        saveBtnClass={classes.saveNoteBtn}
                        textOne={"Add New Goal"}
                        textTwo={"Save"}
                      />
                    </>
                  )}

                  {profile?.user?.type === "staff" &&
                    data?.data?.approvalStatus === "pending" && (
                      <Box className={classes.rejectedNote}>
                        <Box className={classes.rejectionIconBox}>
                          <NotePendingSvg />
                          <Text ff={"Inter"} fz={14} fw={500} color="#000">
                            Pending Approval
                          </Text>
                        </Box>
                      </Box>
                    )}
                  {staffSignature?.signature ||
                  staffSignature?.signatureImage ? (
                    <Flex justify="flex-end">
                      <img
                        src={
                          decrypt(staffSignature?.signature) ||
                          decrypt(staffSignature?.signatureImage)
                        }
                        alt="signature"
                        className={classes.signatureImg}
                      />
                    </Flex>
                  ) : staffSignature?.signatureText ? (
                    <Flex justify="flex-end" mt={10}>
                      <Text
                        fz={32}
                        fw={400}
                        ff="Island Moments"
                        color="#171717"
                      >
                        {staffSignature?.signatureText}
                      </Text>
                    </Flex>
                  ) : null}
                </Box>
              )}
            </form>
          </Drawer>
        </div>
      </div>
    </>
  );
};

export default NoteDrawer;
